function lt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Wt } = Object.prototype, { getPrototypeOf: Re } = Object, se = ((e) => (t) => {
  const r = Wt.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), P = (e) => (e = e.toLowerCase(), (t) => se(t) === e), oe = (e) => (t) => typeof t === e, { isArray: F } = Array, z = oe("undefined");
function Gt(e) {
  return e !== null && !z(e) && e.constructor !== null && !z(e.constructor) && A(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const yt = P("ArrayBuffer");
function Vt(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && yt(e.buffer), t;
}
const zt = oe("string"), A = oe("function"), ft = oe("number"), ae = (e) => e !== null && typeof e == "object", Jt = (e) => e === !0 || e === !1, Q = (e) => {
  if (se(e) !== "object")
    return !1;
  const t = Re(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Kt = P("Date"), Xt = P("File"), Qt = P("Blob"), Yt = P("FileList"), Zt = (e) => ae(e) && A(e.pipe), er = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || A(e.append) && ((t = se(e)) === "formdata" || // detect form-data instance
  t === "object" && A(e.toString) && e.toString() === "[object FormData]"));
}, tr = P("URLSearchParams"), [rr, nr, sr, or] = ["ReadableStream", "Request", "Response", "Headers"].map(P), ar = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function K(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, s;
  if (typeof e != "object" && (e = [e]), F(e))
    for (n = 0, s = e.length; n < s; n++)
      t.call(null, e[n], n, e);
  else {
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), a = o.length;
    let i;
    for (n = 0; n < a; n++)
      i = o[n], t.call(null, e[i], i, e);
  }
}
function mt(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, s;
  for (; n-- > 0; )
    if (s = r[n], t === s.toLowerCase())
      return s;
  return null;
}
const L = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), ht = (e) => !z(e) && e !== L;
function ge() {
  const { caseless: e } = ht(this) && this || {}, t = {}, r = (n, s) => {
    const o = e && mt(t, s) || s;
    Q(t[o]) && Q(n) ? t[o] = ge(t[o], n) : Q(n) ? t[o] = ge({}, n) : F(n) ? t[o] = n.slice() : t[o] = n;
  };
  for (let n = 0, s = arguments.length; n < s; n++)
    arguments[n] && K(arguments[n], r);
  return t;
}
const ir = (e, t, r, { allOwnKeys: n } = {}) => (K(t, (s, o) => {
  r && A(s) ? e[o] = lt(s, r) : e[o] = s;
}, { allOwnKeys: n }), e), ur = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), cr = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, dr = (e, t, r, n) => {
  let s, o, a;
  const i = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (s = Object.getOwnPropertyNames(e), o = s.length; o-- > 0; )
      a = s[o], (!n || n(a, e, t)) && !i[a] && (t[a] = e[a], i[a] = !0);
    e = r !== !1 && Re(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, lr = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, yr = (e) => {
  if (!e)
    return null;
  if (F(e))
    return e;
  let t = e.length;
  if (!ft(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, fr = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Re(Uint8Array)), mr = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let s;
  for (; (s = n.next()) && !s.done; ) {
    const o = s.value;
    t.call(e, o[0], o[1]);
  }
}, hr = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, pr = P("HTMLFormElement"), gr = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, s) {
    return n.toUpperCase() + s;
  }
), Ne = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), qr = P("RegExp"), pt = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  K(r, (s, o) => {
    let a;
    (a = t(s, o, e)) !== !1 && (n[o] = a || s);
  }), Object.defineProperties(e, n);
}, wr = (e) => {
  pt(e, (t, r) => {
    if (A(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (A(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, vr = (e, t) => {
  const r = {}, n = (s) => {
    s.forEach((o) => {
      r[o] = !0;
    });
  };
  return F(e) ? n(e) : n(String(e).split(t)), r;
}, $r = () => {
}, _r = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, ye = "abcdefghijklmnopqrstuvwxyz", je = "0123456789", gt = {
  DIGIT: je,
  ALPHA: ye,
  ALPHA_DIGIT: ye + ye.toUpperCase() + je
}, br = (e = 16, t = gt.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Ir(e) {
  return !!(e && A(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Sr = (e) => {
  const t = new Array(10), r = (n, s) => {
    if (ae(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[s] = n;
        const o = F(n) ? [] : {};
        return K(n, (a, i) => {
          const c = r(a, s + 1);
          !z(c) && (o[i] = c);
        }), t[s] = void 0, o;
      }
    }
    return n;
  };
  return r(e, 0);
}, Er = P("AsyncFunction"), Ar = (e) => e && (ae(e) || A(e)) && A(e.then) && A(e.catch), qt = ((e, t) => e ? setImmediate : t ? ((r, n) => (L.addEventListener("message", ({ source: s, data: o }) => {
  s === L && o === r && n.length && n.shift()();
}, !1), (s) => {
  n.push(s), L.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  A(L.postMessage)
), Tr = typeof queueMicrotask < "u" ? queueMicrotask.bind(L) : typeof process < "u" && process.nextTick || qt, l = {
  isArray: F,
  isArrayBuffer: yt,
  isBuffer: Gt,
  isFormData: er,
  isArrayBufferView: Vt,
  isString: zt,
  isNumber: ft,
  isBoolean: Jt,
  isObject: ae,
  isPlainObject: Q,
  isReadableStream: rr,
  isRequest: nr,
  isResponse: sr,
  isHeaders: or,
  isUndefined: z,
  isDate: Kt,
  isFile: Xt,
  isBlob: Qt,
  isRegExp: qr,
  isFunction: A,
  isStream: Zt,
  isURLSearchParams: tr,
  isTypedArray: fr,
  isFileList: Yt,
  forEach: K,
  merge: ge,
  extend: ir,
  trim: ar,
  stripBOM: ur,
  inherits: cr,
  toFlatObject: dr,
  kindOf: se,
  kindOfTest: P,
  endsWith: lr,
  toArray: yr,
  forEachEntry: mr,
  matchAll: hr,
  isHTMLForm: pr,
  hasOwnProperty: Ne,
  hasOwnProp: Ne,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pt,
  freezeMethods: wr,
  toObjectSet: vr,
  toCamelCase: gr,
  noop: $r,
  toFiniteNumber: _r,
  findKey: mt,
  global: L,
  isContextDefined: ht,
  ALPHABET: gt,
  generateString: br,
  isSpecCompliantForm: Ir,
  toJSONObject: Sr,
  isAsyncFn: Er,
  isThenable: Ar,
  setImmediate: qt,
  asap: Tr
};
function w(e, t, r, n, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), s && (this.response = s, this.status = s.status ? s.status : null);
}
l.inherits(w, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const wt = w.prototype, vt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  vt[e] = { value: e };
});
Object.defineProperties(w, vt);
Object.defineProperty(wt, "isAxiosError", { value: !0 });
w.from = (e, t, r, n, s, o) => {
  const a = Object.create(wt);
  return l.toFlatObject(e, a, function(c) {
    return c !== Error.prototype;
  }, (i) => i !== "isAxiosError"), w.call(a, e.message, t, r, n, s), a.cause = e, a.name = e.name, o && Object.assign(a, o), a;
};
const Rr = null;
function qe(e) {
  return l.isPlainObject(e) || l.isArray(e);
}
function $t(e) {
  return l.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Fe(e, t, r) {
  return e ? e.concat(t).map(function(s, o) {
    return s = $t(s), !r && o ? "[" + s + "]" : s;
  }).join(r ? "." : "") : t;
}
function Pr(e) {
  return l.isArray(e) && !e.some(qe);
}
const Cr = l.toFlatObject(l, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ie(e, t, r) {
  if (!l.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, g) {
    return !l.isUndefined(g[p]);
  });
  const n = r.metaTokens, s = r.visitor || u, o = r.dots, a = r.indexes, c = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(t);
  if (!l.isFunction(s))
    throw new TypeError("visitor must be a function");
  function d(m) {
    if (m === null)
      return "";
    if (l.isDate(m))
      return m.toISOString();
    if (!c && l.isBlob(m))
      throw new w("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(m) || l.isTypedArray(m) ? c && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, p, g) {
    let v = m;
    if (m && !g && typeof m == "object") {
      if (l.endsWith(p, "{}"))
        p = n ? p : p.slice(0, -2), m = JSON.stringify(m);
      else if (l.isArray(m) && Pr(m) || (l.isFileList(m) || l.endsWith(p, "[]")) && (v = l.toArray(m)))
        return p = $t(p), v.forEach(function($, T) {
          !(l.isUndefined($) || $ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            a === !0 ? Fe([p], T, o) : a === null ? p : p + "[]",
            d($)
          );
        }), !1;
    }
    return qe(m) ? !0 : (t.append(Fe(g, p, o), d(m)), !1);
  }
  const y = [], f = Object.assign(Cr, {
    defaultVisitor: u,
    convertValue: d,
    isVisitable: qe
  });
  function h(m, p) {
    if (!l.isUndefined(m)) {
      if (y.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      y.push(m), l.forEach(m, function(v, _) {
        (!(l.isUndefined(v) || v === null) && s.call(
          t,
          v,
          l.isString(_) ? _.trim() : _,
          p,
          f
        )) === !0 && h(v, p ? p.concat(_) : [_]);
      }), y.pop();
    }
  }
  if (!l.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function Me(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Pe(e, t) {
  this._pairs = [], e && ie(e, this, t);
}
const _t = Pe.prototype;
_t.append = function(t, r) {
  this._pairs.push([t, r]);
};
_t.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Me);
  } : Me;
  return this._pairs.map(function(s) {
    return r(s[0]) + "=" + r(s[1]);
  }, "").join("&");
};
function Or(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function bt(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || Or, s = r && r.serialize;
  let o;
  if (s ? o = s(t, r) : o = l.isURLSearchParams(t) ? t.toString() : new Pe(t, r).toString(n), o) {
    const a = e.indexOf("#");
    a !== -1 && (e = e.slice(0, a)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class kr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    l.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const We = kr, It = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, xr = typeof URLSearchParams < "u" ? URLSearchParams : Pe, Ur = typeof FormData < "u" ? FormData : null, Hr = typeof Blob < "u" ? Blob : null, Lr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: xr,
    FormData: Ur,
    Blob: Hr
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ce = typeof window < "u" && typeof document < "u", we = typeof navigator == "object" && navigator || void 0, Dr = Ce && (!we || ["ReactNative", "NativeScript", "NS"].indexOf(we.product) < 0), Br = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Nr = Ce && window.location.href || "http://localhost", jr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ce,
  hasStandardBrowserEnv: Dr,
  hasStandardBrowserWebWorkerEnv: Br,
  navigator: we,
  origin: Nr
}, Symbol.toStringTag, { value: "Module" })), E = {
  ...jr,
  ...Lr
};
function Fr(e, t) {
  return ie(e, new E.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, s, o) {
      return E.isNode && l.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Mr(e) {
  return l.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Wr(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const s = r.length;
  let o;
  for (n = 0; n < s; n++)
    o = r[n], t[o] = e[o];
  return t;
}
function St(e) {
  function t(r, n, s, o) {
    let a = r[o++];
    if (a === "__proto__")
      return !0;
    const i = Number.isFinite(+a), c = o >= r.length;
    return a = !a && l.isArray(s) ? s.length : a, c ? (l.hasOwnProp(s, a) ? s[a] = [s[a], n] : s[a] = n, !i) : ((!s[a] || !l.isObject(s[a])) && (s[a] = []), t(r, n, s[a], o) && l.isArray(s[a]) && (s[a] = Wr(s[a])), !i);
  }
  if (l.isFormData(e) && l.isFunction(e.entries)) {
    const r = {};
    return l.forEachEntry(e, (n, s) => {
      t(Mr(n), s, r, 0);
    }), r;
  }
  return null;
}
function Gr(e, t, r) {
  if (l.isString(e))
    try {
      return (t || JSON.parse)(e), l.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Oe = {
  transitional: It,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", s = n.indexOf("application/json") > -1, o = l.isObject(t);
    if (o && l.isHTMLForm(t) && (t = new FormData(t)), l.isFormData(t))
      return s ? JSON.stringify(St(t)) : t;
    if (l.isArrayBuffer(t) || l.isBuffer(t) || l.isStream(t) || l.isFile(t) || l.isBlob(t) || l.isReadableStream(t))
      return t;
    if (l.isArrayBufferView(t))
      return t.buffer;
    if (l.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let i;
    if (o) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Fr(t, this.formSerializer).toString();
      if ((i = l.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return ie(
          i ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return o || s ? (r.setContentType("application/json", !1), Gr(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Oe.transitional, n = r && r.forcedJSONParsing, s = this.responseType === "json";
    if (l.isResponse(t) || l.isReadableStream(t))
      return t;
    if (t && l.isString(t) && (n && !this.responseType || s)) {
      const a = !(r && r.silentJSONParsing) && s;
      try {
        return JSON.parse(t);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? w.from(i, w.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: E.classes.FormData,
    Blob: E.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Oe.headers[e] = {};
});
const ke = Oe, Vr = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), zr = (e) => {
  const t = {};
  let r, n, s;
  return e && e.split(`
`).forEach(function(a) {
    s = a.indexOf(":"), r = a.substring(0, s).trim().toLowerCase(), n = a.substring(s + 1).trim(), !(!r || t[r] && Vr[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Ge = Symbol("internals");
function G(e) {
  return e && String(e).trim().toLowerCase();
}
function Y(e) {
  return e === !1 || e == null ? e : l.isArray(e) ? e.map(Y) : String(e);
}
function Jr(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Kr = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function fe(e, t, r, n, s) {
  if (l.isFunction(n))
    return n.call(this, t, r);
  if (s && (t = r), !!l.isString(t)) {
    if (l.isString(n))
      return t.indexOf(n) !== -1;
    if (l.isRegExp(n))
      return n.test(t);
  }
}
function Xr(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Qr(e, t) {
  const r = l.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(s, o, a) {
        return this[n].call(this, t, s, o, a);
      },
      configurable: !0
    });
  });
}
class ue {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const s = this;
    function o(i, c, d) {
      const u = G(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const y = l.findKey(s, u);
      (!y || s[y] === void 0 || d === !0 || d === void 0 && s[y] !== !1) && (s[y || c] = Y(i));
    }
    const a = (i, c) => l.forEach(i, (d, u) => o(d, u, c));
    if (l.isPlainObject(t) || t instanceof this.constructor)
      a(t, r);
    else if (l.isString(t) && (t = t.trim()) && !Kr(t))
      a(zr(t), r);
    else if (l.isHeaders(t))
      for (const [i, c] of t.entries())
        o(c, i, n);
    else
      t != null && o(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = G(t), t) {
      const n = l.findKey(this, t);
      if (n) {
        const s = this[n];
        if (!r)
          return s;
        if (r === !0)
          return Jr(s);
        if (l.isFunction(r))
          return r.call(this, s, n);
        if (l.isRegExp(r))
          return r.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = G(t), t) {
      const n = l.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || fe(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let s = !1;
    function o(a) {
      if (a = G(a), a) {
        const i = l.findKey(n, a);
        i && (!r || fe(n, n[i], i, r)) && (delete n[i], s = !0);
      }
    }
    return l.isArray(t) ? t.forEach(o) : o(t), s;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, s = !1;
    for (; n--; ) {
      const o = r[n];
      (!t || fe(this, this[o], o, t, !0)) && (delete this[o], s = !0);
    }
    return s;
  }
  normalize(t) {
    const r = this, n = {};
    return l.forEach(this, (s, o) => {
      const a = l.findKey(n, o);
      if (a) {
        r[a] = Y(s), delete r[o];
        return;
      }
      const i = t ? Xr(o) : String(o).trim();
      i !== o && delete r[o], r[i] = Y(s), n[i] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (n, s) => {
      n != null && n !== !1 && (r[s] = t && l.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((s) => n.set(s)), n;
  }
  static accessor(t) {
    const n = (this[Ge] = this[Ge] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function o(a) {
      const i = G(a);
      n[i] || (Qr(s, a), n[i] = !0);
    }
    return l.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
ue.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(ue.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
l.freezeMethods(ue);
const R = ue;
function me(e, t) {
  const r = this || ke, n = t || r, s = R.from(n.headers);
  let o = n.data;
  return l.forEach(e, function(i) {
    o = i.call(r, o, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), o;
}
function Et(e) {
  return !!(e && e.__CANCEL__);
}
function M(e, t, r) {
  w.call(this, e ?? "canceled", w.ERR_CANCELED, t, r), this.name = "CanceledError";
}
l.inherits(M, w, {
  __CANCEL__: !0
});
function At(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new w(
    "Request failed with status code " + r.status,
    [w.ERR_BAD_REQUEST, w.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Yr(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Zr(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let s = 0, o = 0, a;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const d = Date.now(), u = n[o];
    a || (a = d), r[s] = c, n[s] = d;
    let y = o, f = 0;
    for (; y !== s; )
      f += r[y++], y = y % e;
    if (s = (s + 1) % e, s === o && (o = (o + 1) % e), d - a < t)
      return;
    const h = u && d - u;
    return h ? Math.round(f * 1e3 / h) : void 0;
  };
}
function en(e, t) {
  let r = 0, n = 1e3 / t, s, o;
  const a = (d, u = Date.now()) => {
    r = u, s = null, o && (clearTimeout(o), o = null), e.apply(null, d);
  };
  return [(...d) => {
    const u = Date.now(), y = u - r;
    y >= n ? a(d, u) : (s = d, o || (o = setTimeout(() => {
      o = null, a(s);
    }, n - y)));
  }, () => s && a(s)];
}
const te = (e, t, r = 3) => {
  let n = 0;
  const s = Zr(50, 250);
  return en((o) => {
    const a = o.loaded, i = o.lengthComputable ? o.total : void 0, c = a - n, d = s(c), u = a <= i;
    n = a;
    const y = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: c,
      rate: d || void 0,
      estimated: d && i && u ? (i - a) / d : void 0,
      event: o,
      lengthComputable: i != null,
      [t ? "download" : "upload"]: !0
    };
    e(y);
  }, r);
}, Ve = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, ze = (e) => (...t) => l.asap(() => e(...t)), tn = E.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = E.navigator && /(msie|trident)/i.test(E.navigator.userAgent), r = document.createElement("a");
    let n;
    function s(o) {
      let a = o;
      return t && (r.setAttribute("href", a), a = r.href), r.setAttribute("href", a), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = s(window.location.href), function(a) {
      const i = l.isString(a) ? s(a) : a;
      return i.protocol === n.protocol && i.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
), rn = E.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, s, o) {
      const a = [e + "=" + encodeURIComponent(t)];
      l.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), l.isString(n) && a.push("path=" + n), l.isString(s) && a.push("domain=" + s), o === !0 && a.push("secure"), document.cookie = a.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function nn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function sn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Tt(e, t) {
  return e && !nn(t) ? sn(e, t) : t;
}
const Je = (e) => e instanceof R ? { ...e } : e;
function D(e, t) {
  t = t || {};
  const r = {};
  function n(d, u, y) {
    return l.isPlainObject(d) && l.isPlainObject(u) ? l.merge.call({ caseless: y }, d, u) : l.isPlainObject(u) ? l.merge({}, u) : l.isArray(u) ? u.slice() : u;
  }
  function s(d, u, y) {
    if (l.isUndefined(u)) {
      if (!l.isUndefined(d))
        return n(void 0, d, y);
    } else
      return n(d, u, y);
  }
  function o(d, u) {
    if (!l.isUndefined(u))
      return n(void 0, u);
  }
  function a(d, u) {
    if (l.isUndefined(u)) {
      if (!l.isUndefined(d))
        return n(void 0, d);
    } else
      return n(void 0, u);
  }
  function i(d, u, y) {
    if (y in t)
      return n(d, u);
    if (y in e)
      return n(void 0, d);
  }
  const c = {
    url: o,
    method: o,
    data: o,
    baseURL: a,
    transformRequest: a,
    transformResponse: a,
    paramsSerializer: a,
    timeout: a,
    timeoutMessage: a,
    withCredentials: a,
    withXSRFToken: a,
    adapter: a,
    responseType: a,
    xsrfCookieName: a,
    xsrfHeaderName: a,
    onUploadProgress: a,
    onDownloadProgress: a,
    decompress: a,
    maxContentLength: a,
    maxBodyLength: a,
    beforeRedirect: a,
    transport: a,
    httpAgent: a,
    httpsAgent: a,
    cancelToken: a,
    socketPath: a,
    responseEncoding: a,
    validateStatus: i,
    headers: (d, u) => s(Je(d), Je(u), !0)
  };
  return l.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const y = c[u] || s, f = y(e[u], t[u], u);
    l.isUndefined(f) && y !== i || (r[u] = f);
  }), r;
}
const Rt = (e) => {
  const t = D({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: s, xsrfCookieName: o, headers: a, auth: i } = t;
  t.headers = a = R.from(a), t.url = bt(Tt(t.baseURL, t.url), e.params, e.paramsSerializer), i && a.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  );
  let c;
  if (l.isFormData(r)) {
    if (E.hasStandardBrowserEnv || E.hasStandardBrowserWebWorkerEnv)
      a.setContentType(void 0);
    else if ((c = a.getContentType()) !== !1) {
      const [d, ...u] = c ? c.split(";").map((y) => y.trim()).filter(Boolean) : [];
      a.setContentType([d || "multipart/form-data", ...u].join("; "));
    }
  }
  if (E.hasStandardBrowserEnv && (n && l.isFunction(n) && (n = n(t)), n || n !== !1 && tn(t.url))) {
    const d = s && o && rn.read(o);
    d && a.set(s, d);
  }
  return t;
}, on = typeof XMLHttpRequest < "u", an = on && function(e) {
  return new Promise(function(r, n) {
    const s = Rt(e);
    let o = s.data;
    const a = R.from(s.headers).normalize();
    let { responseType: i, onUploadProgress: c, onDownloadProgress: d } = s, u, y, f, h, m;
    function p() {
      h && h(), m && m(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let g = new XMLHttpRequest();
    g.open(s.method.toUpperCase(), s.url, !0), g.timeout = s.timeout;
    function v() {
      if (!g)
        return;
      const $ = R.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), b = {
        data: !i || i === "text" || i === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: $,
        config: e,
        request: g
      };
      At(function(H) {
        r(H), p();
      }, function(H) {
        n(H), p();
      }, b), g = null;
    }
    "onloadend" in g ? g.onloadend = v : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, g.onabort = function() {
      g && (n(new w("Request aborted", w.ECONNABORTED, e, g)), g = null);
    }, g.onerror = function() {
      n(new w("Network Error", w.ERR_NETWORK, e, g)), g = null;
    }, g.ontimeout = function() {
      let T = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const b = s.transitional || It;
      s.timeoutErrorMessage && (T = s.timeoutErrorMessage), n(new w(
        T,
        b.clarifyTimeoutError ? w.ETIMEDOUT : w.ECONNABORTED,
        e,
        g
      )), g = null;
    }, o === void 0 && a.setContentType(null), "setRequestHeader" in g && l.forEach(a.toJSON(), function(T, b) {
      g.setRequestHeader(b, T);
    }), l.isUndefined(s.withCredentials) || (g.withCredentials = !!s.withCredentials), i && i !== "json" && (g.responseType = s.responseType), d && ([f, m] = te(d, !0), g.addEventListener("progress", f)), c && g.upload && ([y, h] = te(c), g.upload.addEventListener("progress", y), g.upload.addEventListener("loadend", h)), (s.cancelToken || s.signal) && (u = ($) => {
      g && (n(!$ || $.type ? new M(null, e, g) : $), g.abort(), g = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const _ = Yr(s.url);
    if (_ && E.protocols.indexOf(_) === -1) {
      n(new w("Unsupported protocol " + _ + ":", w.ERR_BAD_REQUEST, e));
      return;
    }
    g.send(o || null);
  });
}, un = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), s;
    const o = function(d) {
      if (!s) {
        s = !0, i();
        const u = d instanceof Error ? d : this.reason;
        n.abort(u instanceof w ? u : new M(u instanceof Error ? u.message : u));
      }
    };
    let a = t && setTimeout(() => {
      a = null, o(new w(`timeout ${t} of ms exceeded`, w.ETIMEDOUT));
    }, t);
    const i = () => {
      e && (a && clearTimeout(a), a = null, e.forEach((d) => {
        d.unsubscribe ? d.unsubscribe(o) : d.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((d) => d.addEventListener("abort", o));
    const { signal: c } = n;
    return c.unsubscribe = () => l.asap(i), c;
  }
}, cn = un, dn = function* (e, t) {
  let r = e.byteLength;
  if (!t || r < t) {
    yield e;
    return;
  }
  let n = 0, s;
  for (; n < r; )
    s = n + t, yield e.slice(n, s), n = s;
}, ln = async function* (e, t) {
  for await (const r of yn(e))
    yield* dn(r, t);
}, yn = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, Ke = (e, t, r, n) => {
  const s = ln(e, t);
  let o = 0, a, i = (c) => {
    a || (a = !0, n && n(c));
  };
  return new ReadableStream({
    async pull(c) {
      try {
        const { done: d, value: u } = await s.next();
        if (d) {
          i(), c.close();
          return;
        }
        let y = u.byteLength;
        if (r) {
          let f = o += y;
          r(f);
        }
        c.enqueue(new Uint8Array(u));
      } catch (d) {
        throw i(d), d;
      }
    },
    cancel(c) {
      return i(c), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, ce = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Pt = ce && typeof ReadableStream == "function", fn = ce && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Ct = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, mn = Pt && Ct(() => {
  let e = !1;
  const t = new Request(E.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Xe = 64 * 1024, ve = Pt && Ct(() => l.isReadableStream(new Response("").body)), re = {
  stream: ve && ((e) => e.body)
};
ce && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !re[t] && (re[t] = l.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new w(`Response type '${t}' is not supported`, w.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const hn = async (e) => {
  if (e == null)
    return 0;
  if (l.isBlob(e))
    return e.size;
  if (l.isSpecCompliantForm(e))
    return (await new Request(E.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (l.isArrayBufferView(e) || l.isArrayBuffer(e))
    return e.byteLength;
  if (l.isURLSearchParams(e) && (e = e + ""), l.isString(e))
    return (await fn(e)).byteLength;
}, pn = async (e, t) => {
  const r = l.toFiniteNumber(e.getContentLength());
  return r ?? hn(t);
}, gn = ce && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: s,
    cancelToken: o,
    timeout: a,
    onDownloadProgress: i,
    onUploadProgress: c,
    responseType: d,
    headers: u,
    withCredentials: y = "same-origin",
    fetchOptions: f
  } = Rt(e);
  d = d ? (d + "").toLowerCase() : "text";
  let h = cn([s, o && o.toAbortSignal()], a), m;
  const p = h && h.unsubscribe && (() => {
    h.unsubscribe();
  });
  let g;
  try {
    if (c && mn && r !== "get" && r !== "head" && (g = await pn(u, n)) !== 0) {
      let b = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), k;
      if (l.isFormData(n) && (k = b.headers.get("content-type")) && u.setContentType(k), b.body) {
        const [H, X] = Ve(
          g,
          te(ze(c))
        );
        n = Ke(b.body, Xe, H, X);
      }
    }
    l.isString(y) || (y = y ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    m = new Request(t, {
      ...f,
      signal: h,
      method: r.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: v ? y : void 0
    });
    let _ = await fetch(m);
    const $ = ve && (d === "stream" || d === "response");
    if (ve && (i || $ && p)) {
      const b = {};
      ["status", "statusText", "headers"].forEach((Be) => {
        b[Be] = _[Be];
      });
      const k = l.toFiniteNumber(_.headers.get("content-length")), [H, X] = i && Ve(
        k,
        te(ze(i), !0)
      ) || [];
      _ = new Response(
        Ke(_.body, Xe, H, () => {
          X && X(), p && p();
        }),
        b
      );
    }
    d = d || "text";
    let T = await re[l.findKey(re, d) || "text"](_, e);
    return !$ && p && p(), await new Promise((b, k) => {
      At(b, k, {
        data: T,
        headers: R.from(_.headers),
        status: _.status,
        statusText: _.statusText,
        config: e,
        request: m
      });
    });
  } catch (v) {
    throw p && p(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new w("Network Error", w.ERR_NETWORK, e, m),
      {
        cause: v.cause || v
      }
    ) : w.from(v, v && v.code, e, m);
  }
}), $e = {
  http: Rr,
  xhr: an,
  fetch: gn
};
l.forEach($e, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Qe = (e) => `- ${e}`, qn = (e) => l.isFunction(e) || e === null || e === !1, Ot = {
  getAdapter: (e) => {
    e = l.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const s = {};
    for (let o = 0; o < t; o++) {
      r = e[o];
      let a;
      if (n = r, !qn(r) && (n = $e[(a = String(r)).toLowerCase()], n === void 0))
        throw new w(`Unknown adapter '${a}'`);
      if (n)
        break;
      s[a || "#" + o] = n;
    }
    if (!n) {
      const o = Object.entries(s).map(
        ([i, c]) => `adapter ${i} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let a = t ? o.length > 1 ? `since :
` + o.map(Qe).join(`
`) : " " + Qe(o[0]) : "as no adapter specified";
      throw new w(
        "There is no suitable adapter to dispatch the request " + a,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: $e
};
function he(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new M(null, e);
}
function Ye(e) {
  return he(e), e.headers = R.from(e.headers), e.data = me.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Ot.getAdapter(e.adapter || ke.adapter)(e).then(function(n) {
    return he(e), n.data = me.call(
      e,
      e.transformResponse,
      n
    ), n.headers = R.from(n.headers), n;
  }, function(n) {
    return Et(n) || (he(e), n && n.response && (n.response.data = me.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = R.from(n.response.headers))), Promise.reject(n);
  });
}
const kt = "1.7.7", xe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  xe[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ze = {};
xe.transitional = function(t, r, n) {
  function s(o, a) {
    return "[Axios v" + kt + "] Transitional option '" + o + "'" + a + (n ? ". " + n : "");
  }
  return (o, a, i) => {
    if (t === !1)
      throw new w(
        s(a, " has been removed" + (r ? " in " + r : "")),
        w.ERR_DEPRECATED
      );
    return r && !Ze[a] && (Ze[a] = !0, console.warn(
      s(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(o, a, i) : !0;
  };
};
function wn(e, t, r) {
  if (typeof e != "object")
    throw new w("options must be an object", w.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let s = n.length;
  for (; s-- > 0; ) {
    const o = n[s], a = t[o];
    if (a) {
      const i = e[o], c = i === void 0 || a(i, o, e);
      if (c !== !0)
        throw new w("option " + o + " must be " + c, w.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new w("Unknown option " + o, w.ERR_BAD_OPTION);
  }
}
const _e = {
  assertOptions: wn,
  validators: xe
}, x = _e.validators;
let ne = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new We(),
      response: new We()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let s;
        Error.captureStackTrace ? Error.captureStackTrace(s = {}) : s = new Error();
        const o = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? o && !String(n.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + o) : n.stack = o;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = D(this.defaults, r);
    const { transitional: n, paramsSerializer: s, headers: o } = r;
    n !== void 0 && _e.assertOptions(n, {
      silentJSONParsing: x.transitional(x.boolean),
      forcedJSONParsing: x.transitional(x.boolean),
      clarifyTimeoutError: x.transitional(x.boolean)
    }, !1), s != null && (l.isFunction(s) ? r.paramsSerializer = {
      serialize: s
    } : _e.assertOptions(s, {
      encode: x.function,
      serialize: x.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let a = o && l.merge(
      o.common,
      o[r.method]
    );
    o && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete o[m];
      }
    ), r.headers = R.concat(a, o);
    const i = [];
    let c = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(r) === !1 || (c = c && p.synchronous, i.unshift(p.fulfilled, p.rejected));
    });
    const d = [];
    this.interceptors.response.forEach(function(p) {
      d.push(p.fulfilled, p.rejected);
    });
    let u, y = 0, f;
    if (!c) {
      const m = [Ye.bind(this), void 0];
      for (m.unshift.apply(m, i), m.push.apply(m, d), f = m.length, u = Promise.resolve(r); y < f; )
        u = u.then(m[y++], m[y++]);
      return u;
    }
    f = i.length;
    let h = r;
    for (y = 0; y < f; ) {
      const m = i[y++], p = i[y++];
      try {
        h = m(h);
      } catch (g) {
        p.call(this, g);
        break;
      }
    }
    try {
      u = Ye.call(this, h);
    } catch (m) {
      return Promise.reject(m);
    }
    for (y = 0, f = d.length; y < f; )
      u = u.then(d[y++], d[y++]);
    return u;
  }
  getUri(t) {
    t = D(this.defaults, t);
    const r = Tt(t.baseURL, t.url);
    return bt(r, t.params, t.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(t) {
  ne.prototype[t] = function(r, n) {
    return this.request(D(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(o, a, i) {
      return this.request(D(i || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: a
      }));
    };
  }
  ne.prototype[t] = r(), ne.prototype[t + "Form"] = r(!0);
});
const Z = ne;
class Ue {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const n = this;
    this.promise.then((s) => {
      if (!n._listeners)
        return;
      let o = n._listeners.length;
      for (; o-- > 0; )
        n._listeners[o](s);
      n._listeners = null;
    }), this.promise.then = (s) => {
      let o;
      const a = new Promise((i) => {
        n.subscribe(i), o = i;
      }).then(s);
      return a.cancel = function() {
        n.unsubscribe(o);
      }, a;
    }, t(function(o, a, i) {
      n.reason || (n.reason = new M(o, a, i), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Ue(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
}
const vn = Ue;
function $n(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function _n(e) {
  return l.isObject(e) && e.isAxiosError === !0;
}
const be = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(be).forEach(([e, t]) => {
  be[t] = e;
});
const bn = be;
function xt(e) {
  const t = new Z(e), r = lt(Z.prototype.request, t);
  return l.extend(r, Z.prototype, t, { allOwnKeys: !0 }), l.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(s) {
    return xt(D(e, s));
  }, r;
}
const I = xt(ke);
I.Axios = Z;
I.CanceledError = M;
I.CancelToken = vn;
I.isCancel = Et;
I.VERSION = kt;
I.toFormData = ie;
I.AxiosError = w;
I.Cancel = I.CanceledError;
I.all = function(t) {
  return Promise.all(t);
};
I.spread = $n;
I.isAxiosError = _n;
I.mergeConfig = D;
I.AxiosHeaders = R;
I.formToJSON = (e) => St(l.isHTMLForm(e) ? new FormData(e) : e);
I.getAdapter = Ot.getAdapter;
I.HttpStatusCode = bn;
I.default = I;
const W = I;
var In = Symbol("cache-parser");
function et(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function B(e) {
  return (typeof e == "string" || typeof e == "number") && (e = Number(e)) >= 0 && e < 1 / 0;
}
function C(e) {
  return e === !0 || typeof e == "number" || typeof e == "string" && e !== "false";
}
var N = Number;
function Ut(e) {
  var t = Object.defineProperty({}, In, { enumerable: !1, value: 1 });
  if (!e || typeof e != "string")
    return t;
  var r = function(d) {
    for (var u, y = {}, f = function(p, g) {
      var v = typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
      if (v)
        return (v = v.call(p)).next.bind(v);
      if (Array.isArray(p) || (v = function($, T) {
        if ($) {
          if (typeof $ == "string")
            return et($, T);
          var b = Object.prototype.toString.call($).slice(8, -1);
          return b === "Object" && $.constructor && (b = $.constructor.name), b === "Map" || b === "Set" ? Array.from($) : b === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(b) ? et($, T) : void 0;
        }
      }(p))) {
        v && (p = v);
        var _ = 0;
        return function() {
          return _ >= p.length ? { done: !0 } : { done: !1, value: p[_++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }(d.toLowerCase().replace(/\s+/g, "").split(",")); !(u = f()).done; ) {
      var h, m = u.value.split("=", 2);
      y[m[0]] = (h = m[1]) == null || h;
    }
    return y;
  }(e), n = r["max-age"], s = r["max-stale"], o = r["min-fresh"], a = r["s-maxage"], i = r["stale-if-error"], c = r["stale-while-revalidate"];
  return C(r.immutable) && (t.immutable = !0), B(n) && (t.maxAge = N(n)), B(s) && (t.maxStale = N(s)), B(o) && (t.minFresh = N(o)), C(r["must-revalidate"]) && (t.mustRevalidate = !0), C(r["must-understand"]) && (t.mustUnderstand = !0), C(r["no-cache"]) && (t.noCache = !0), C(r["no-store"]) && (t.noStore = !0), C(r["no-transform"]) && (t.noTransform = !0), C(r["only-if-cached"]) && (t.onlyIfCached = !0), C(r.private) && (t.private = !0), C(r["proxy-revalidate"]) && (t.proxyRevalidate = !0), C(r.public) && (t.public = !0), B(a) && (t.sMaxAge = N(a)), B(i) && (t.staleIfError = N(i)), B(c) && (t.staleWhileRevalidate = N(c)), t;
}
var Sn = Symbol();
function En() {
  var e, t, r = new Promise(function(n, s) {
    e = n, t = s;
  });
  return r.resolve = e, r.reject = t, r[Sn] = 1, r;
}
function An(e, t) {
  return e > t ? 1 : -1;
}
function ee(e, t) {
  var r = 5381;
  if (typeof e == "object" && e !== null && (e.toString === Object.prototype.toString || e.toString === Array.prototype.toString)) {
    t || (t = /* @__PURE__ */ new WeakSet());
    for (var n = Object.keys(e).sort(An), s = 0; s < n.length; s++) {
      var o = n[s], a = e[o];
      if (r = 33 * r ^ ee(o, t), typeof a == "object" && a !== null && (e.toString === Object.prototype.toString || e.toString === Array.prototype.toString)) {
        if (t.has(a))
          continue;
        t.add(a);
      }
      r = 33 * r ^ ee(a, t);
    }
    return 33 * r ^ ee(e.constructor, t);
  }
  var i = typeof e;
  try {
    e instanceof Date ? i += e.getTime() : i += String(e);
  } catch {
    i += String(Object.assign({}, e));
  }
  for (var c = 0; c < i.length; c++)
    r = 33 * r ^ i.charCodeAt(c);
  return r;
}
/*!
 * Axios Cache Interceptor 1.5.3
 * (c) 2021-present Arthur Fiorette & Contributors
 * Released under the MIT License.
 */
const S = Object.freeze({
  /**
   * ```txt
   * If-Modified-Since: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since
   */
  IfModifiedSince: "if-modified-since",
  /**
   * ```txt
   * Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified
   */
  LastModified: "last-modified",
  /**
   * ```txt
   * If-None-Match: "<etag_value>"
   * If-None-Match: "<etag_value>", "<etag_value>", …
   * If-None-Match: *
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-None-Match
   */
  IfNoneMatch: "if-none-match",
  /**
   * ```txt
   * Cache-Control: max-age=604800
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
   */
  CacheControl: "cache-control",
  /**
   * ```txt
   * Pragma: no - cache;
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Pragma
   */
  Pragma: "pragma",
  /**
   * ```txt
   * ETag: W / '<etag_value>';
   * ETag: '<etag_value>';
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ETag
   */
  ETag: "etag",
  /**
   * ```txt
   * Expires: <http-date>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expires
   */
  Expires: "expires",
  /**
   * ```txt
   * Age: <delta-seconds>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Age
   */
  Age: "age",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state Contains a string of ASCII characters that can be used as ETag for
   * `If-Match` header Provided by user using `cache.etag` value.
   *
   * ```txt
   * X-Axios-Cache-Etag: "<etag_value>"
   * ```
   */
  XAxiosCacheEtag: "x-axios-cache-etag",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state may contain `'use-cache-timestamp'` if `cache.modifiedSince` is
   * `true`, otherwise will contain a date from `cache.modifiedSince`. If a date is
   * provided, it can be used for `If-Modified-Since` header, otherwise the cache
   * timestamp can be used for `If-Modified-Since` header.
   *
   * ```txt
   * X-Axios-Cache-Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * X-Axios-Cache-Last-Modified: use-cache-timestamp
   * ```
   */
  XAxiosCacheLastModified: "x-axios-cache-last-modified",
  /**
   * Used internally as metadata to mark the cache item able to be used if the server
   * returns an error. The stale-if-error response directive indicates that the cache can
   * reuse a stale response when any error occurs.
   *
   * ```txt
   * XAxiosCacheStaleIfError: <seconds>
   * ```
   */
  XAxiosCacheStaleIfError: "x-axios-cache-stale-if-error"
}), Tn = (e) => {
  if (!e)
    return "not enough headers";
  const t = e[S.CacheControl];
  if (t) {
    const {
      noCache: n,
      noStore: s,
      maxAge: o,
      maxStale: a,
      immutable: i,
      staleWhileRevalidate: c
    } = Ut(String(t));
    if (n || s)
      return "dont cache";
    if (i)
      return {
        cache: 1e3 * 60 * 60 * 24 * 365
      };
    if (o !== void 0) {
      const d = e[S.Age];
      return {
        cache: d ? (
          // If age is present, we must subtract it from maxAge
          (o - Number(d)) * 1e3
        ) : o * 1e3,
        // Already out of date, must be requested again
        stale: (
          // I couldn't find any documentation about who should be used, as they
          // are not meant to overlap each other. But, as we cannot request in the
          // background, as the stale-while-revalidate says, and we just increase
          // its staleTtl when its present, max-stale is being preferred over
          // stale-while-revalidate.
          a !== void 0 ? a * 1e3 : c !== void 0 ? c * 1e3 : void 0
        )
      };
    }
  }
  const r = e[S.Expires];
  if (r) {
    const n = Date.parse(String(r)) - Date.now();
    return n >= 0 ? {
      cache: n
    } : "dont cache";
  }
  return "not enough headers";
};
function J() {
  return J = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, J.apply(this, arguments);
}
function Rn(e) {
  return e ? (t) => e(t) || t === 304 : (t) => t >= 200 && t < 300 || t === 304;
}
function Ie(e = "get", t = []) {
  return e = e.toLowerCase(), t.some((r) => r === e);
}
function Pn(e, t) {
  t.headers || (t.headers = {});
  const {
    etag: r,
    modifiedSince: n
  } = t.cache;
  if (r) {
    var s;
    const o = r === !0 ? (s = e.data) == null ? void 0 : s.headers[S.ETag] : r;
    o && (t.headers[S.IfNoneMatch] = o);
  }
  n && (t.headers[S.IfModifiedSince] = n === !0 ? (
    // If last-modified is not present, use the createdAt timestamp
    e.data.headers[S.LastModified] || new Date(e.createdAt).toUTCString()
  ) : n.toUTCString());
}
function Cn(e, t) {
  return e.status === 304 && t ? (e.cached = !0, e.data = t.data, e.status = t.status, e.statusText = t.statusText, e.headers = J({}, t.headers, e.headers), t) : {
    data: e.data,
    status: e.status,
    statusText: e.statusText,
    headers: e.headers
  };
}
function On(e) {
  const t = async (r) => {
    if (r.id = e.generateKey(r), r.cache === !1)
      return r;
    if (r.cache = J({}, e.defaults.cache, r.cache), typeof r.cache.cachePredicate == "object" && r.cache.cachePredicate.ignoreUrls && r.url) {
      for (const p of r.cache.cachePredicate.ignoreUrls)
        if (p instanceof RegExp ? (
          // Handles stateful regexes
          // biome-ignore lint: reduces the number of checks
          (p.lastIndex = 0, p.test(r.url))
        ) : r.url.includes(p))
          return r;
    }
    if (r.cache.cacheTakeover) {
      var n, s, o, a, i, c, d, u, y;
      (o = (n = r.headers)[s = S.CacheControl]) != null || (n[s] = "no-cache"), (c = (a = r.headers)[i = S.Pragma]) != null || (a[i] = "no-cache"), (y = (d = r.headers)[u = S.Expires]) != null || (d[u] = "0");
    }
    if (!Ie(r.method, r.cache.methods))
      return r;
    let f = await e.storage.get(r.id, r);
    const h = r.cache.override;
    e:
      if (f.state === "empty" || f.state === "stale" || f.state === "must-revalidate" || h) {
        if (e.waiting[r.id] && !h && (f = await e.storage.get(r.id, r), f.state !== "empty" && f.state !== "must-revalidate"))
          break e;
        return e.waiting[r.id] = En(), e.waiting[r.id].catch(() => {
        }), await e.storage.set(r.id, {
          state: "loading",
          previous: h ? (
            // Simply determine if the request is stale or not
            // based if it had previous data or not
            f.data ? "stale" : "empty"
          ) : (
            // Typescript doesn't know that cache.state here can only be 'empty' or 'stale'
            f.state
          ),
          data: f.data,
          // If the cache is empty and asked to override it, use the current timestamp
          createdAt: h && !f.createdAt ? Date.now() : f.createdAt
        }, r), (f.state === "stale" || f.state === "must-revalidate") && Pn(f, r), r.validateStatus = Rn(r.validateStatus), (f.state === "stale" || f.data && f.state !== "must-revalidate") && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(f)), r;
      }
    let m;
    if (f.state === "loading") {
      const p = e.waiting[r.id];
      if (!p)
        return f.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(f)), r;
      try {
        m = await p;
      } catch {
        return f.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(f)), t(r);
      }
    } else
      m = f.data;
    return r.transformResponse = void 0, r.adapter = function() {
      return Promise.resolve({
        config: r,
        data: m.data,
        headers: m.headers,
        status: m.status,
        statusText: m.statusText,
        cached: !0,
        id: r.id
      });
    }, r;
  };
  return {
    onFulfilled: t,
    apply: () => e.interceptors.request.use(t)
  };
}
async function kn(e, t) {
  if (typeof t == "function")
    return t(e);
  const {
    statusCheck: r,
    responseMatch: n,
    containsHeaders: s
  } = t;
  if (r && !await r(e.status) || n && !await n(e))
    return !1;
  if (s)
    for (const [a, i] of Object.entries(s)) {
      var o;
      if (!await i(
        // Avoid bugs in case the header is not in lower case
        (o = e.headers[a.toLowerCase()]) != null ? o : e.headers[a]
      ))
        return !1;
    }
  return !0;
}
async function xn(e, t, r) {
  if (typeof r == "function")
    return r(t);
  for (const [n, s] of Object.entries(r)) {
    if (s === "delete") {
      await e.remove(n, t.config);
      continue;
    }
    const o = await e.get(n, t.config);
    if (o.state === "loading")
      continue;
    const a = await s(o, t);
    if (a === "delete") {
      await e.remove(n, t.config);
      continue;
    }
    a !== "ignore" && await e.set(n, a, t.config);
  }
}
function Un(e) {
  const t = async (s, o) => {
    var a;
    await e.storage.remove(s, o), (a = e.waiting[s]) == null || a.reject(), delete e.waiting[s];
  }, r = async (s) => {
    var o;
    if (!(s != null && s.config))
      throw s;
    s.id = s.config.id, (o = s.cached) != null || (s.cached = !1);
    const a = s.config, i = a.cache;
    if (s.cached)
      return s;
    if (!i)
      return s.cached = !1, s;
    if (i.update && await xn(e.storage, s, i.update), !Ie(a.method, i.methods))
      return s;
    const c = await e.storage.get(s.id, a);
    if (
      // If the request interceptor had a problem or it wasn't cached
      c.state !== "loading"
    )
      return s;
    if (
      // For 'loading' values (previous: stale), this check already ran in the past.
      !c.data && !await kn(s, i.cachePredicate)
    )
      return await t(s.id, a), s;
    for (const m of Object.keys(s.headers))
      m.startsWith("x-axios-cache") && delete s.headers[m];
    i.etag && i.etag !== !0 && (s.headers[S.XAxiosCacheEtag] = i.etag), i.modifiedSince && (s.headers[S.XAxiosCacheLastModified] = i.modifiedSince === !0 ? "use-cache-timestamp" : i.modifiedSince.toUTCString());
    let d = i.ttl || -1, u;
    if (i.interpretHeader) {
      const m = e.headerInterpreter(s.headers);
      if (m === "dont cache")
        return await t(s.id, a), s;
      m !== "not enough headers" && (typeof m == "number" ? d = m : (d = m.cache, u = m.stale));
    }
    const y = Cn(s, c.data);
    typeof d == "function" && (d = await d(s)), i.staleIfError && (s.headers[S.XAxiosCacheStaleIfError] = String(d));
    const f = {
      state: "cached",
      ttl: d,
      staleTtl: u,
      createdAt: Date.now(),
      data: y
    }, h = e.waiting[s.id];
    return h && (h.resolve(f.data), delete e.waiting[s.id]), await e.storage.set(s.id, f, a), s;
  }, n = async (s) => {
    if (!s.isAxiosError || !s.config)
      throw s;
    const o = s.config, a = o.id, i = o.cache, c = s.response;
    if (!i || !a)
      throw s;
    if (!Ie(o.method, i.methods))
      throw await t(a, o), s;
    const d = await e.storage.get(a, o);
    if (
      // This will only not be loading if the interceptor broke
      d.state !== "loading" || d.previous !== "stale"
    )
      throw await t(a, o), s;
    if (i.staleIfError) {
      const y = String(c == null ? void 0 : c.headers[S.CacheControl]), f = y && Ut(y).staleIfError, h = typeof i.staleIfError == "function" ? await i.staleIfError(c, d, s) : i.staleIfError === !0 && f ? f * 1e3 : i.staleIfError;
      if (h === !0 || // staleIfError is the number of seconds that stale is allowed to be used
      typeof h == "number" && d.createdAt + h > Date.now()) {
        var u;
        return (u = e.waiting[a]) == null || u.resolve(d.data), delete e.waiting[a], await e.storage.set(a, {
          state: "stale",
          createdAt: Date.now(),
          data: d.data
        }, o), {
          cached: !0,
          config: o,
          id: a,
          data: d.data.data,
          headers: d.data.headers,
          status: d.data.status,
          statusText: d.data.statusText
        };
      }
    }
    throw await t(a, o), s;
  };
  return {
    onFulfilled: r,
    onRejected: n,
    apply: () => e.interceptors.response.use(r, n)
  };
}
const Hn = (e) => !!e && !!e["is-storage"];
function Ht(e) {
  const t = e.data.headers;
  return S.ETag in t || S.LastModified in t || S.XAxiosCacheEtag in t || S.XAxiosCacheLastModified in t;
}
function Ln(e) {
  return String(e.data.headers[S.CacheControl]).includes("must-revalidate");
}
function Lt(e) {
  return Ht(e) ? !0 : e.state === "cached" && e.staleTtl !== void 0 && // Only allow stale values after the ttl is already in the past and the staleTtl is in the future.
  // In cases that just createdAt + ttl > Date.now(), isn't enough because the staleTtl could be <= 0.
  // This logic only returns true when Date.now() is between the (createdAt + ttl) and (createdAt + ttl + staleTtl).
  // Following the example below:
  // |--createdAt--:--ttl--:---staleTtl--->
  // [        past        ][now is in here]
  Math.abs(Date.now() - (e.createdAt + e.ttl)) <= e.staleTtl;
}
function Se(e) {
  return e.ttl !== void 0 && e.createdAt + e.ttl <= Date.now();
}
function Dn({
  set: e,
  find: t,
  remove: r
}) {
  return {
    //@ts-expect-error - we don't want to expose this
    "is-storage": 1,
    set: e,
    remove: r,
    get: async (n, s) => {
      let o = await t(n, s);
      if (!o)
        return {
          state: "empty"
        };
      if (o.state === "empty" || o.state === "loading" || o.state === "must-revalidate")
        return o;
      if (o.state === "cached") {
        if (!Se(o))
          return o;
        if (!Lt(o))
          return await r(n, s), {
            state: "empty"
          };
        if (o = {
          state: "stale",
          createdAt: o.createdAt,
          data: o.data,
          ttl: o.staleTtl !== void 0 ? o.staleTtl + o.ttl : void 0
        }, await e(n, o, s), Ln(o))
          return J({}, o, {
            state: "must-revalidate"
          });
      }
      return !Se(o) || Ht(o) ? o : (await r(n, s), {
        state: "empty"
      });
    }
  };
}
function Bn(e = !1, t = !1, r = !1) {
  const n = Dn({
    set: (s, o) => {
      if (r) {
        let a = Object.keys(n.data);
        if (a.length >= r)
          for (n.cleanup(), a = Object.keys(n.data); a.length >= r; )
            delete n.data[a.shift()];
      }
      n.data[s] = // Clone the value before storing to prevent future mutations
      // from affecting cached data.
      e === "double" ? (
        /* c8 ignore next 3 */
        typeof structuredClone == "function" ? structuredClone(o) : JSON.parse(JSON.stringify(o))
      ) : o;
    },
    remove: (s) => {
      delete n.data[s];
    },
    find: (s) => {
      const o = n.data[s];
      return e && o !== void 0 ? typeof structuredClone == "function" ? structuredClone(o) : JSON.parse(JSON.stringify(o)) : o;
    }
  });
  return n.data = /* @__PURE__ */ Object.create(null), n.cleanup = () => {
    const s = Object.keys(n.data);
    let o = -1, a, i;
    for (; ++o < s.length; ) {
      if (i = s[o], a = n.data[i], a.state === "empty") {
        n.remove(i);
        continue;
      }
      a.state === "cached" && Se(a) && !Lt(a) && n.remove(i);
    }
  }, t && (n.cleaner = setInterval(n.cleanup, t)), n;
}
const tt = /^\/|\/$/g;
function Nn(e) {
  return (t) => {
    if (t.id)
      return t.id;
    const r = e(t);
    return typeof r == "string" || typeof r == "number" ? `${r}` : `${ee(r)}`;
  };
}
const jn = Nn(({
  baseURL: e,
  url: t,
  method: r,
  params: n,
  data: s
}) => (e !== void 0 ? e = e.replace(tt, "") : e = "", t !== void 0 ? t = t.replace(tt, "") : t = "", r !== void 0 ? r = r.toLowerCase() : r = "get", {
  url: e + (e && t ? "/" : "") + t,
  params: n,
  method: r,
  data: s
}));
function de(e, t = {}) {
  var r, n, s, o, a, i, c, d;
  const u = e;
  if (u.defaults.cache)
    throw new Error("setupCache() should be called only once");
  if (u.storage = t.storage || Bn(), !Hn(u.storage))
    throw new Error("Use buildStorage() function");
  return u.waiting = t.waiting || {}, u.generateKey = t.generateKey || jn, u.headerInterpreter = t.headerInterpreter || Tn, u.requestInterceptor = t.requestInterceptor || On(u), u.responseInterceptor = t.responseInterceptor || Un(u), u.debug = t.debug || function() {
  }, u.defaults.cache = {
    update: t.update || {},
    ttl: (r = t.ttl) != null ? r : 1e3 * 60 * 5,
    // Although RFC 7231 also marks POST as cacheable, most users don't know that
    // and may have problems about why their "create X" route not working.
    methods: t.methods || ["get", "head"],
    cachePredicate: t.cachePredicate || {
      // All cacheable status codes defined in RFC 7231
      statusCheck: (y) => [200, 203, 300, 301, 302, 404, 405, 410, 414, 501].includes(y)
    },
    etag: (n = t.etag) != null ? n : !0,
    // This option is going to be ignored by servers when ETag is enabled
    // Checks strict equality to false to avoid undefined-ish values
    modifiedSince: (s = t.modifiedSince) != null ? s : t.etag === !1,
    interpretHeader: (o = t.interpretHeader) != null ? o : !0,
    cacheTakeover: (a = t.cacheTakeover) != null ? a : !0,
    staleIfError: (i = t.staleIfError) != null ? i : !0,
    override: (c = t.override) != null ? c : !1,
    hydrate: (d = t.hydrate) != null ? d : void 0
  }, u.requestInterceptor.apply(), u.responseInterceptor.apply(), u;
}
const Dt = {
  "access-token": "",
  client: "",
  uid: ""
}, Fn = ({
  apiUrl: e,
  getDeviceUniqueId: t,
  interceptors: r,
  locale: n,
  source: s,
  storageClient: o
}) => {
  const a = `${e}/${n}/api/`, i = de(
    W.create({
      baseURL: `${a}`,
      headers: { ...Dt }
    })
  ), c = async (y) => {
    if (y && y.headers && y.headers["access-token"]) {
      const f = {
        accessToken: y.headers["access-token"],
        client: y.headers.client,
        uid: y.headers.uid,
        httpSource: s
      };
      o == null || o.setItem("headers", JSON.stringify(f));
    }
  }, d = (y) => {
    y.interceptors.response.use(
      function(f) {
        return c(f), Array.isArray(r == null ? void 0 : r.response) && (r == null || r.response.forEach((h) => h(f))), f.data.data || f.data.success ? {
          ...f.data,
          headers: f.headers,
          included: f.data.included
        } : {
          data: f.data,
          headers: f.headers,
          included: f.data.included
        };
      },
      (f) => (f.response && c(f.response), Promise.reject(f))
    );
  };
  return ((y) => {
    y.interceptors.request.use(
      async function(f) {
        const h = await (o == null ? void 0 : o.getItem("headers"));
        return h && (f.headers["access-token"] = JSON.parse(h).accessToken, f.headers.client = JSON.parse(h).client, f.headers.uid = JSON.parse(h).uid, f.headers.httpSource = JSON.parse(h).httpSource), t && (f.headers.deviceIdentifier = await t()), f;
      },
      (f) => Promise.reject(f)
    );
  })(i), d(i), i;
}, Mn = ({ apiUrl: e }) => {
  const t = `${e}/`;
  return de(
    W.create({
      baseURL: `${t}`,
      headers: {
        "Content-Type": "application/json"
      }
    })
  );
}, Wn = ({ apiUrl: e }) => {
  const t = `${e}/`;
  return de(
    W.create({
      baseURL: `${t}`,
      headers: {
        "Content-Type": "application/json"
      }
    })
  );
}, Gn = ({ apiUrl: e }) => {
  const t = `${e}/`;
  return W.create({
    baseURL: `${t}`,
    headers: {
      "Content-Type": "application/json"
    }
  });
}, Vn = ({ apiUrl: e }) => {
  const t = `${e}/api/`;
  return W.create({
    baseURL: `${t}`,
    headers: Dt
  });
}, zn = ({ apiUrl: e }) => {
  const t = `${e}/`;
  return de(
    W.create({
      baseURL: t,
      headers: {
        "Content-Type": "application/json"
      }
    })
  );
}, V = {
  lc: (e) => Fn(e),
  mindee: (e) => Mn(e),
  abtest: (e) => Wn(e),
  ipLocation: (e) => Gn(e),
  sharegroop: (e) => zn(e),
  strapiAdmin: (e) => Vn(e)
}, rt = (e) => e.relationships ? Jn(e) : {
  id: e.id,
  type: e.type,
  ...e.meta ? { meta: e.meta } : {},
  ...e.attributes
}, nt = (e) => {
  const t = {};
  return e && Object.keys(e).forEach((n) => {
    const s = e == null ? void 0 : e[n].data;
    Array.isArray(s) ? t[`${n}Ids`] = s.map(({ id: o }) => o) : t[`${n}Id`] = (s == null ? void 0 : s.id) || null;
  }), t;
}, st = (e) => {
  const t = e.relationships, r = e.attributes;
  return e != null && e.attributes ? { id: e.id, ...r, ...nt(t) } : { ...e, ...nt(t) };
}, Jn = (e) => {
  var n;
  const t = {}, r = e == null ? void 0 : e.relationships;
  if (r)
    for (const [s, o] of Object.entries(r))
      Array.isArray(o.data) ? t[`${s}Ids`] = o.data.map((a) => a.id) : t[`${s}Id`] = (n = o.data) == null ? void 0 : n.id;
  return {
    id: e.id,
    type: e.type,
    ...e.attributes,
    ...e.meta ? { meta: e.meta } : {},
    ...t
  };
}, ot = (e) => Array.isArray(e) ? e.map((t) => rt(t)) : rt(e), Kn = (e) => {
  const t = {}, r = {};
  return e.map((n) => n.type).forEach((n) => {
    t[n] ? t[n] = 1 + 1 : t[n] = 1;
  }), Object.values(t).forEach((n, s) => {
    const o = Object.keys(t)[s], a = e.filter((c) => c.type === o), i = e.find((c) => c.type === o);
    n > 1 ? r[`${o}s`] = ot(a) : i && (r[`${o}s`] = ot(i));
  }), r;
}, U = (e) => {
  const { data: t, headers: r, included: n, meta: s } = e;
  if (t && typeof t != "string") {
    const o = Array.isArray(t) ? t.map((i) => st(i)) : st(t), a = n ? Kn(n) : null;
    return {
      data: o,
      headers: r,
      ...s ? { meta: s } : {},
      ...a ? { included: a } : {}
    };
  }
  return e;
}, j = ({
  api: e,
  locale: t,
  storageClient: r,
  unserialized: n = !1
}) => {
  const s = {
    apiUrl: e.url,
    interceptors: e.interceptors,
    locale: t,
    storageClient: r,
    source: e.source,
    getDeviceUniqueId: e.getDeviceUniqueId
  };
  return {
    get: async (o, a) => {
      try {
        const i = await V[e.name](s).get(o, a);
        return a != null && a.responseType ? Promise.resolve(i) : n ? e.name === "strapiAdmin" ? Promise.resolve(i.data) : Promise.resolve(i) : Promise.resolve(
          U(i)
        );
      } catch (i) {
        return Promise.resolve({
          errors: i
        });
      }
    },
    post: async (o, a, i) => {
      try {
        const c = await V[e.name](s).post(
          o,
          a,
          i
        );
        return n ? Promise.resolve(c) : Promise.resolve(U(c));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    put: async (o, a, i) => {
      try {
        const c = await V[e.name](s).put(
          o,
          a,
          i
        );
        return n ? Promise.resolve(c) : Promise.resolve(U(c));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    delete: async (o) => {
      try {
        const a = await V[e.name](s).delete(o);
        return n ? Promise.resolve(a) : Promise.resolve(U(a));
      } catch (a) {
        return Promise.resolve({
          errors: a
        });
      }
    },
    raw: async (o, a) => {
      const i = await V[e.name](s).request({
        url: o,
        method: "GET",
        ...a,
        responseType: a.responseType.toLowerCase()
      });
      return {
        headers: new Headers(Object.entries(i.headers)),
        _data: i.data
      };
    }
  };
}, Xn = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, Qn = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, Yn = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function Zn(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    es(e);
    return;
  }
  return t;
}
function es(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function ts(e, t = {}) {
  if (typeof e != "string")
    return e;
  const r = e.trim();
  if (
    // eslint-disable-next-line unicorn/prefer-at
    e[0] === '"' && e.endsWith('"') && !e.includes("\\")
  )
    return r.slice(1, -1);
  if (r.length <= 9) {
    const n = r.toLowerCase();
    if (n === "true")
      return !0;
    if (n === "false")
      return !1;
    if (n === "undefined")
      return;
    if (n === "null")
      return null;
    if (n === "nan")
      return Number.NaN;
    if (n === "infinity")
      return Number.POSITIVE_INFINITY;
    if (n === "-infinity")
      return Number.NEGATIVE_INFINITY;
  }
  if (!Yn.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (Xn.test(e) || Qn.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, Zn);
    }
    return JSON.parse(e);
  } catch (n) {
    if (t.strict)
      throw n;
    return e;
  }
}
const rs = /#/g, ns = /&/g, ss = /\//g, os = /=/g, He = /\+/g, as = /%5e/gi, is = /%60/gi, us = /%7c/gi, cs = /%20/gi;
function ds(e) {
  return encodeURI("" + e).replace(us, "|");
}
function Ee(e) {
  return ds(typeof e == "string" ? e : JSON.stringify(e)).replace(He, "%2B").replace(cs, "+").replace(rs, "%23").replace(ns, "%26").replace(is, "`").replace(as, "^").replace(ss, "%2F");
}
function pe(e) {
  return Ee(e).replace(os, "%3D");
}
function Bt(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function ls(e) {
  return Bt(e.replace(He, " "));
}
function ys(e) {
  return Bt(e.replace(He, " "));
}
function fs(e = "") {
  const t = {};
  e[0] === "?" && (e = e.slice(1));
  for (const r of e.split("&")) {
    const n = r.match(/([^=]+)=?(.*)/) || [];
    if (n.length < 2)
      continue;
    const s = ls(n[1]);
    if (s === "__proto__" || s === "constructor")
      continue;
    const o = ys(n[2] || "");
    t[s] === void 0 ? t[s] = o : Array.isArray(t[s]) ? t[s].push(o) : t[s] = [t[s], o];
  }
  return t;
}
function ms(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map((r) => `${pe(e)}=${Ee(r)}`).join("&") : `${pe(e)}=${Ee(t)}` : pe(e);
}
function hs(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => ms(t, e[t])).filter(Boolean).join("&");
}
const ps = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, gs = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, qs = /^([/\\]\s*){2,}[^/\\]/, ws = /\/$|\/\?|\/#/, vs = /^\.?\//;
function Nt(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? ps.test(e) : gs.test(e) || (t.acceptRelative ? qs.test(e) : !1);
}
function Ae(e = "", t) {
  return t ? ws.test(e) : e.endsWith("/");
}
function $s(e = "", t) {
  if (!t)
    return (Ae(e) ? e.slice(0, -1) : e) || "/";
  if (!Ae(e, !0))
    return e || "/";
  let r = e, n = "";
  const s = e.indexOf("#");
  s >= 0 && (r = e.slice(0, s), n = e.slice(s));
  const [o, ...a] = r.split("?");
  return ((o.endsWith("/") ? o.slice(0, -1) : o) || "/") + (a.length > 0 ? `?${a.join("?")}` : "") + n;
}
function _s(e = "", t) {
  if (!t)
    return e.endsWith("/") ? e : e + "/";
  if (Ae(e, !0))
    return e || "/";
  let r = e, n = "";
  const s = e.indexOf("#");
  if (s >= 0 && (r = e.slice(0, s), n = e.slice(s), !r))
    return n;
  const [o, ...a] = r.split("?");
  return o + "/" + (a.length > 0 ? `?${a.join("?")}` : "") + n;
}
function bs(e, t) {
  if (Ss(t) || Nt(e))
    return e;
  const r = $s(t);
  return e.startsWith(r) ? e : As(r, e);
}
function Is(e, t) {
  const r = Ft(e), n = { ...fs(r.search), ...t };
  return r.search = hs(n), Ts(r);
}
function Ss(e) {
  return !e || e === "/";
}
function Es(e) {
  return e && e !== "/";
}
function As(e, ...t) {
  let r = e || "";
  for (const n of t.filter((s) => Es(s)))
    if (r) {
      const s = n.replace(vs, "");
      r = _s(r) + s;
    } else
      r = n;
  return r;
}
const jt = Symbol.for("ufo:protocolRelative");
function Ft(e = "", t) {
  const r = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (r) {
    const [, y, f = ""] = r;
    return {
      protocol: y.toLowerCase(),
      pathname: f,
      href: y + f,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!Nt(e, { acceptRelative: !0 }))
    return t ? Ft(t + e) : at(e);
  const [, n = "", s, o = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, a = "", i = ""] = o.match(/([^#/?]*)(.*)?/) || [];
  n === "file:" && (i = i.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: c, search: d, hash: u } = at(i);
  return {
    protocol: n.toLowerCase(),
    auth: s ? s.slice(0, Math.max(0, s.length - 1)) : "",
    host: a,
    pathname: c,
    search: d,
    hash: u,
    [jt]: !n
  };
}
function at(e = "") {
  const [t = "", r = "", n = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: r,
    hash: n
  };
}
function Ts(e) {
  const t = e.pathname || "", r = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", n = e.hash || "", s = e.auth ? e.auth + "@" : "", o = e.host || "";
  return (e.protocol || e[jt] ? (e.protocol || "") + "//" : "") + s + o + t + r + n;
}
class Rs extends Error {
  constructor(t, r) {
    super(t, r), this.name = "FetchError", r != null && r.cause && !this.cause && (this.cause = r.cause);
  }
}
function Ps(e) {
  var c, d, u, y, f;
  const t = ((c = e.error) == null ? void 0 : c.message) || ((d = e.error) == null ? void 0 : d.toString()) || "", r = ((u = e.request) == null ? void 0 : u.method) || ((y = e.options) == null ? void 0 : y.method) || "GET", n = ((f = e.request) == null ? void 0 : f.url) || String(e.request) || "/", s = `[${r}] ${JSON.stringify(n)}`, o = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", a = `${s}: ${o}${t ? ` ${t}` : ""}`, i = new Rs(
    a,
    e.error ? { cause: e.error } : void 0
  );
  for (const h of ["request", "options", "response"])
    Object.defineProperty(i, h, {
      get() {
        return e[h];
      }
    });
  for (const [h, m] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(i, h, {
      get() {
        return e.response && e.response[m];
      }
    });
  return i;
}
const Cs = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function it(e = "GET") {
  return Cs.has(e.toUpperCase());
}
function Os(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const ks = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), xs = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function Us(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return xs.test(t) ? "json" : ks.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function Hs(e, t, r = globalThis.Headers) {
  const n = {
    ...t,
    ...e
  };
  if (t != null && t.params && (e != null && e.params) && (n.params = {
    ...t == null ? void 0 : t.params,
    ...e == null ? void 0 : e.params
  }), t != null && t.query && (e != null && e.query) && (n.query = {
    ...t == null ? void 0 : t.query,
    ...e == null ? void 0 : e.query
  }), t != null && t.headers && (e != null && e.headers)) {
    n.headers = new r((t == null ? void 0 : t.headers) || {});
    for (const [s, o] of new r((e == null ? void 0 : e.headers) || {}))
      n.headers.set(s, o);
  }
  return n;
}
const Ls = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  //  Gateway Timeout
]), Ds = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function Mt(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: r = globalThis.Headers,
    AbortController: n = globalThis.AbortController
  } = e;
  async function s(i) {
    const c = i.error && i.error.name === "AbortError" && !i.options.timeout || !1;
    if (i.options.retry !== !1 && !c) {
      let u;
      typeof i.options.retry == "number" ? u = i.options.retry : u = it(i.options.method) ? 0 : 1;
      const y = i.response && i.response.status || 500;
      if (u > 0 && (Array.isArray(i.options.retryStatusCodes) ? i.options.retryStatusCodes.includes(y) : Ls.has(y))) {
        const f = i.options.retryDelay || 0;
        return f > 0 && await new Promise((h) => setTimeout(h, f)), o(i.request, {
          ...i.options,
          retry: u - 1
        });
      }
    }
    const d = Ps(i);
    throw Error.captureStackTrace && Error.captureStackTrace(d, o), d;
  }
  const o = async function(c, d = {}) {
    var h;
    const u = {
      request: c,
      options: Hs(d, e.defaults, r),
      response: void 0,
      error: void 0
    };
    u.options.method = (h = u.options.method) == null ? void 0 : h.toUpperCase(), u.options.onRequest && await u.options.onRequest(u), typeof u.request == "string" && (u.options.baseURL && (u.request = bs(u.request, u.options.baseURL)), (u.options.query || u.options.params) && (u.request = Is(u.request, {
      ...u.options.params,
      ...u.options.query
    }))), u.options.body && it(u.options.method) && (Os(u.options.body) ? (u.options.body = typeof u.options.body == "string" ? u.options.body : JSON.stringify(u.options.body), u.options.headers = new r(u.options.headers || {}), u.options.headers.has("content-type") || u.options.headers.set("content-type", "application/json"), u.options.headers.has("accept") || u.options.headers.set("accept", "application/json")) : (
      // ReadableStream Body
      ("pipeTo" in u.options.body && typeof u.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof u.options.body.pipe == "function") && ("duplex" in u.options || (u.options.duplex = "half"))
    ));
    let y;
    if (!u.options.signal && u.options.timeout) {
      const m = new n();
      y = setTimeout(
        () => m.abort(),
        u.options.timeout
      ), u.options.signal = m.signal;
    }
    try {
      u.response = await t(
        u.request,
        u.options
      );
    } catch (m) {
      return u.error = m, u.options.onRequestError && await u.options.onRequestError(u), await s(u);
    } finally {
      y && clearTimeout(y);
    }
    if (u.response.body && !Ds.has(u.response.status) && u.options.method !== "HEAD") {
      const m = (u.options.parseResponse ? "json" : u.options.responseType) || Us(u.response.headers.get("content-type") || "");
      switch (m) {
        case "json": {
          const p = await u.response.text(), g = u.options.parseResponse || ts;
          u.response._data = g(p);
          break;
        }
        case "stream": {
          u.response._data = u.response.body;
          break;
        }
        default:
          u.response._data = await u.response[m]();
      }
    }
    return u.options.onResponse && await u.options.onResponse(u), !u.options.ignoreResponseError && u.response.status >= 400 && u.response.status < 600 ? (u.options.onResponseError && await u.options.onResponseError(u), await s(u)) : u.response;
  }, a = async function(c, d) {
    return (await o(c, d))._data;
  };
  return a.raw = o, a.native = (...i) => t(...i), a.create = (i = {}) => Mt({
    ...e,
    defaults: {
      ...e.defaults,
      ...i
    }
  }), a;
}
const Le = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}(), Bs = Le.fetch || (() => Promise.reject(new Error("[ofetch] global.fetch is not supported!"))), Ns = Le.Headers, js = Le.AbortController, O = Mt({ fetch: Bs, Headers: Ns, AbortController: js }), Fs = ({
  apiUrl: e,
  interceptors: t,
  locale: r,
  source: n,
  storageClient: s
}) => {
  const o = (c, d) => {
    const u = /* @__PURE__ */ new Date();
    `${u.getDate()}`, u.getMonth() + 1, `${u.getFullYear()}${u.getHours()}${u.getMinutes()}${u.getSeconds()}`;
  }, a = (c) => {
    const d = (c == null ? void 0 : c.get("access-token")) || "", u = (c == null ? void 0 : c.get("client")) || "", y = (c == null ? void 0 : c.get("uid")) || "";
    return {
      accessToken: d,
      client: u,
      uid: y
    };
  }, i = (c) => {
    const { accessToken: d, client: u, uid: y } = a(c.headers);
    d && u && y && (s == null || s.setItem("accessToken", d), s == null || s.setItem("client", u), s == null || s.setItem("uid", y));
  };
  return {
    triggerOnResponse: (c, d) => (i(c), process.env.SSR_LOG === "true" && o(), Array.isArray(t == null ? void 0 : t.response) && (t == null || t.response.forEach((u) => u(c))), c.status === 200 ? { ...c } : Promise.reject({
      response: { data: c._data, status: c.status }
    })),
    getHeaders: async () => {
      const c = await (s == null ? void 0 : s.getItem("accessToken")), d = await (s == null ? void 0 : s.getItem("client")), u = await (s == null ? void 0 : s.getItem("uid"));
      let y = { Httpsource: n };
      return c && d && u && (y = {
        "access-token": c,
        client: d,
        uid: u,
        Httpsource: y.Httpsource
      }), y;
    }
  };
}, Ms = ({
  api: e,
  locale: t,
  storageClient: r,
  headersCustom: n,
  localeCustom: s
}) => {
  const o = (i) => `${e.url}/${i}/api/`, a = Fs({
    apiUrl: e.url,
    getDeviceUniqueId: e.getDeviceUniqueId,
    interceptors: e.interceptors,
    locale: t,
    source: e.source,
    storageClient: r
  });
  return {
    get: async (i, c) => {
      try {
        const d = s == null ? void 0 : s.getLocale(), u = o(d || t), y = n != null && n.getHeaders() ? n.getHeaders() : await a.getHeaders(), f = await O(`${u}${i}`, {
          method: "GET",
          onResponse: ({ response: h }) => a.triggerOnResponse(
            h,
            i
          ),
          ...c ?? {},
          headers: { ...y, ...(c == null ? void 0 : c.headers) ?? {} }
        });
        return c != null && c.responseType ? Promise.resolve(f) : Promise.resolve(
          U(f)
        );
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    post: async (i, c, d) => {
      try {
        const u = s == null ? void 0 : s.getLocale(), y = o(u || t), f = n != null && n.getHeaders() ? n.getHeaders() : await a.getHeaders(), h = await O(`${y}${i}`, {
          method: "POST",
          body: c,
          onResponse: ({ response: m }) => a.triggerOnResponse(
            m,
            i
          ),
          ...d ?? {},
          headers: { ...f, ...(d == null ? void 0 : d.headers) ?? {} }
        });
        return Promise.resolve(
          U(h)
        );
      } catch (u) {
        return Promise.resolve({
          errors: u
        });
      }
    },
    put: async (i, c, d) => {
      try {
        const u = s == null ? void 0 : s.getLocale(), y = o(u || t), f = n != null && n.getHeaders() ? n.getHeaders() : await a.getHeaders(), h = await O(`${y}${i}`, {
          method: "PUT",
          body: c,
          onResponse: ({ response: m }) => a.triggerOnResponse(
            m,
            i
          ),
          ...d ?? {},
          headers: { ...f, ...(d == null ? void 0 : d.headers) ?? {} }
        });
        return Promise.resolve(
          U(h)
        );
      } catch (u) {
        return Promise.resolve({
          errors: u
        });
      }
    },
    delete: async (i) => {
      try {
        const c = s == null ? void 0 : s.getLocale(), d = o(c || t), u = n != null && n.getHeaders() ? n.getHeaders() : await a.getHeaders(), y = await O(`${d}${i}`, {
          method: "DELETE",
          headers: u,
          onResponse: ({ response: f }) => a.triggerOnResponse(
            f,
            i
          )
        });
        return Promise.resolve(
          U(y)
        );
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    raw: async (i, c) => {
      const d = (s == null ? void 0 : s.getLocale()) ?? t, u = o(d), y = n != null && n.getHeaders() ? n.getHeaders() : await a.getHeaders(), f = await O.raw(`${u}${i}`, {
        method: "GET",
        onResponse: ({ response: h }) => a.triggerOnResponse(
          h,
          i
        ),
        ...c,
        headers: { ...y, ...c.headers ?? {} }
      });
      return { headers: f.headers, _data: f._data };
    }
  };
}, ut = (e) => {
  const t = e.fields && Object.entries(e.fields).map(
    (r) => `filter[${r[0]}]=${r[1].operation}:${r[1].value}`
  );
  return e.sort ? t ? `${t.join("&")}&sort=${e.sort}` : `sort=${e.sort}` : t && t.join("&");
}, ct = (e) => {
  const t = e.include && e.include.join(), r = e.fields && Object.entries(e.fields).map(
    (n) => `fields[${n[0]}]=${n[1].join()}`
  );
  if (t && r)
    return `include=${t}&${r.join("&")}`;
  if (!t && r)
    return r.join("&");
  if (t && !r)
    return `include=${t}`;
}, q = ({
  includes: e,
  filter: t,
  pagination: r = { page: "1", per: "25" }
}) => {
  const n = `page=${r.page}&per=${r.per}`;
  return e && !t ? `?${ct(e)}&${n}` : t && !e ? `?${ut(t)}&${n}` : t && e ? `?${ct(e)}&${ut(
    t
  )}&${n}` : !t && !e && r ? `?${n}` : "";
}, Te = (e, t) => {
  const r = { ...e };
  for (const n in t)
    t[n] instanceof Object && !Array.isArray(t[n]) && e[n] ? r[n] = Te(e[n], t[n]) : r.hasOwnProperty(n) || (r[n] = t[n]);
  return r;
}, Ws = (e) => ({
  query: (t) => e.get(`v3/user/houses/${t.houseId}/areas_equipments`)
}), dt = (e) => {
  let t = e[0].toUpperCase();
  for (let r = 1; r < e.length; r++)
    [" ", "-"].includes(e[r - 1]) ? t += e[r].toUpperCase() : t += e[r].toLowerCase();
  return t;
}, le = ({ api: e }) => {
  const t = `${e.url}/`;
  return {
    get: async (r, n) => {
      try {
        const s = await O(`${t}${r}`, {
          method: "GET",
          ...n
        });
        return n != null && n.responseType, Promise.resolve(s);
      } catch (s) {
        return Promise.resolve({
          errors: s
        });
      }
    },
    post: async (r, n, s) => {
      try {
        const o = await O(`${t}${r}`, {
          method: "POST",
          body: n,
          ...s
        });
        return Promise.resolve(o);
      } catch (o) {
        return Promise.resolve({
          errors: o
        });
      }
    },
    put: async (r, n, s) => {
      try {
        const o = await O(`${t}${r}`, {
          method: "PUT",
          body: n,
          ...s
        });
        return Promise.resolve(o);
      } catch (o) {
        return Promise.resolve({
          errors: o
        });
      }
    },
    delete: async (r) => {
      try {
        const n = await O(`${t}${r}`, {
          method: "DELETE"
        });
        return Promise.resolve(n);
      } catch (n) {
        return Promise.resolve({
          errors: n
        });
      }
    }
  };
};
class Vc {
  constructor(t) {
    this.provider = t, this.headers = {}, this.http = {}, this.apiUrl = "", this.headers = {
      headers: { Authorization: `Token ${this.provider.apiKey}` }
    }, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(t) {
    const r = { name: "mindee", url: this.apiUrl };
    return t === "axios" ? j({ api: r, unserialized: !0 }) : le({ api: r });
  }
  getPredictData(t, r) {
    return t.reduce(
      (n, s) => {
        const o = [
          "surname",
          "given_names",
          "alternate_name"
        ].includes(s);
        if (Array.isArray(r[s])) {
          const a = r[s];
          n[s] = a.filter((i) => i.value).map((i) => o ? dt(i.value) : i.value);
        } else {
          const a = r[s];
          a.value && (n[s] = o ? dt(a.value) : a.value);
        }
        return n;
      },
      {}
    );
  }
  dataFormatter(t) {
    return t.map((r) => {
      const n = Object.keys(r.prediction);
      return this.getPredictData(n, r.prediction);
    });
  }
  async verifyPassport(t) {
    const r = await this.http.post(
      "v1/products/mindee/passport/v1/predict",
      { document: t },
      this.headers
    ).then(
      (s) => typeof s.data == "object" ? s : { data: s }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
  async verifyIdentityCard(t) {
    const r = await this.http.post(
      "v1/products/mindee/idcard_fr/v2/predict",
      { document: t },
      this.headers
    ).then(
      (s) => typeof s.data == "object" ? s : { data: s }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
}
class zc {
  constructor(t) {
    this.provider = t, this.amplitudeApiUrl = "", this.experimentApiUrl = "", this.amplitudeLabApiUrl = "", this.amplitudeLabHeaders = {}, this.experimentHeaders = {}, this.amplitudeApiKey = "", this.httpTracking = {}, this.httpAmplitudeLab = {}, this.httpExperiment = {}, this.amplitudeLabHeaders = {
      headers: { Authorization: `Api-Key ${this.provider.amplitudeApiKey}` }
    }, this.experimentHeaders = {
      headers: { Authorization: `Bearer ${this.provider.experimentApiKey}` }
    }, this.amplitudeApiKey = this.provider.amplitudeApiKey, this.amplitudeApiUrl = this.provider.amplitudeApiUrl, this.amplitudeLabApiUrl = this.provider.amplitudeLabApiUrl, this.experimentApiUrl = this.provider.experimentApiUrl, this.httpTracking = this.setHttp(
      this.provider.httpClientType,
      this.amplitudeApiUrl
    ), this.httpAmplitudeLab = this.setHttp(
      this.provider.httpClientType,
      this.amplitudeLabApiUrl
    ), this.httpExperiment = this.setHttp(
      this.provider.httpClientType,
      this.experimentApiUrl
    );
  }
  setHttp(t, r) {
    const n = { name: "abtest", url: r };
    return t === "axios" ? j({ api: n, unserialized: !0 }) : le({ api: n });
  }
  // Récupère la liste des experiments (par défaut en cours et décidées)
  async getExperiments(t = ["running", "decision-made"]) {
    try {
      return ((await this.httpExperiment.get(
        "api/1/experiments",
        this.experimentHeaders
      )).experiments ?? []).filter((n) => t.includes(n.state)).map((n) => ({
        id: n.id,
        key: n.key,
        state: n.state,
        variants: n.variants
      }));
    } catch (r) {
      return console.error("Failed to get experiments", r), [];
    }
  }
  // Récupère le variant a associé au user pour chaque flagkey (flagkey étant l'id d'une experiment)
  async getUserVariant({
    flagKey: t,
    deviceId: r,
    userId: n
  }) {
    const s = {
      query: {
        flag_key: t,
        ...r ? { device_id: r } : {},
        ...n ? { user_id: n } : {}
      },
      ...this.amplitudeLabHeaders
    };
    try {
      const o = await this.httpAmplitudeLab.get(
        "v1/vardata",
        s
      );
      return t in o ? o[t].key : "control";
    } catch (o) {
      return console.error("Failed to get user variant", o), "";
    }
  }
  // Permet de tracker lorsque le user commence une experiment (clique sur un bouton or whatever)
  async sendExposure({
    deviceId: t,
    userId: r,
    flagKey: n,
    variant: s
  }) {
    const o = {
      api_key: this.amplitudeApiKey,
      events: [
        {
          event_type: "$exposure",
          device_id: t,
          event_properties: {
            flag_key: n,
            variant: s
          },
          ...r ? { user_id: r } : {}
        }
      ]
    };
    try {
      return await this.httpTracking.post("2/httpapi", o);
    } catch (a) {
      console.error(a);
    }
  }
  async getUserVariants({
    deviceId: t,
    userId: r
  }) {
    const n = {};
    try {
      const s = await this.getExperiments();
      if (s && (s == null ? void 0 : s.length) > 0)
        for (const o of s)
          try {
            const a = await this.getUserVariant({
              flagKey: o.key,
              deviceId: t,
              userId: r
            });
            n[o.key] = a;
          } catch (a) {
            console.error(
              `Failed to get variant for key: ${o.key}`,
              a
            );
          }
      return { experiments: s, userVariant: n };
    } catch (s) {
      console.error(s);
    }
  }
  async getUserVariantsV2({
    deviceId: t,
    userId: r
  }) {
    try {
      const n = await this.getExperiments(), s = [];
      if (n && (n == null ? void 0 : n.length) > 0)
        for (const i of n)
          s.push(
            this.getUserVariant({
              flagKey: i.key,
              deviceId: t,
              userId: r
            })
          );
      const a = (await Promise.all(s)).reduce(
        (i, c, d) => (i[n[d].key] = c, i),
        {}
      );
      return { experiments: n, userVariants: a };
    } catch (n) {
      return console.error(n), { experiments: [], userVariants: {} };
    }
  }
}
class Jc {
  constructor(t) {
    this.provider = t, this.apiKey = "", this.http = {}, this.apiUrl = "", this.apiKey = this.provider.apiKey, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(t) {
    const r = { name: "ipLocation", url: this.apiUrl };
    return t === "axios" ? j({ api: r, unserialized: !0 }) : le({ api: r });
  }
  async getUserLocation() {
    var r, n, s, o, a, i, c, d, u, y, f, h, m, p;
    const t = await this.http.get(`?key=${this.apiKey}`).then(
      (g) => typeof g.data == "object" ? g : { data: g }
    ).catch(console.error);
    if (t != null && t.data)
      return {
        location: {
          countryCode: (s = (n = (r = t.data) == null ? void 0 : r.location) == null ? void 0 : n.country) == null ? void 0 : s.code,
          country: (i = (a = (o = t.data) == null ? void 0 : o.location) == null ? void 0 : a.country) == null ? void 0 : i.name,
          city: (d = (c = t.data) == null ? void 0 : c.location) == null ? void 0 : d.city,
          postal: (y = (u = t.data) == null ? void 0 : u.location) == null ? void 0 : y.postal
        },
        currency: (h = (f = t.data) == null ? void 0 : f.currency) == null ? void 0 : h.code,
        timezone: (p = (m = t.data) == null ? void 0 : m.time_zone) == null ? void 0 : p.id
      };
  }
}
class Gs {
  constructor(t) {
    this.httpOptions = {}, this.http = {}, this.apiUrl = "", this.httpOptions = {
      headers: { Authorization: t.apiKey }
    }, this.apiUrl = t.apiUrl;
    const r = { name: "sharegroop", url: this.apiUrl };
    this.http = t.httpClientType === "axios" ? j({ api: r, unserialized: !0 }) : le({ api: r });
  }
  async getOrderById(t) {
    return (await this.http.get(`v1/orders/${t}`, this.httpOptions)).data;
  }
}
Gs.SUCCESSFUL_STATUSES = [
  "completed",
  "confirmed",
  "pendingCommit"
];
const Vs = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.included,
      filter: t.filter,
      pagination: t.paginate
    });
    return e.get(`v3/user/houses${r}`);
  }
}), zs = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes
    });
    return e.get(
      `v3/user/availability_requests/${t.availabilityRequestId}${r}`
    );
  }
}), Js = (e) => ({
  query: (t) => e.put(
    `v3/user/availability_requests/${t.availabilityRequestId}`,
    { availability_request: { ...t } }
  )
}), Ks = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes
    });
    return e.get(`v3/user/awaiting_user_actions${r}`);
  }
}), Xs = (e) => ({
  query: (t) => e.put(`v3/user/owner_nps/${t.id}`, t.body)
}), Qs = (e) => ({
  query: async (t) => {
    var c;
    if (typeof e.raw != "function")
      throw new Error("HttpClient does not implement the .raw method");
    const r = await e.raw(`v3/user/checks/${t.checkId}.pdf`, {
      responseType: "blob"
    }), { headers: n, _data: s } = r;
    if (!s)
      throw new Error("noContent");
    const o = (c = n.get("content-disposition")) == null ? void 0 : c.toString(), [a, i] = (o == null ? void 0 : o.split("filename=")) ?? [];
    if (a != null && a.startsWith("attachment")) {
      const [d] = i.split(";").map((u) => u.replace(/"/g, ""));
      return [s, decodeURIComponent(d)];
    }
    throw new Error("noAttachment");
  }
}), Ys = (e) => ({
  query: (t) => e.post(`v3/user/wishlists/${t.wishlistToken}/houses`, {
    wishlist: t.wishlist
  })
}), Zs = (e) => ({
  query: () => e.get("v3/user/informations")
}), eo = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      pagination: t.pagination
    });
    return e.get(
      `v3/user/wishlists/${t.wishlistToken}/houses${r}`
    );
  }
}), to = (e) => ({
  query: (t) => e.put("v3/user/informations", t)
}), ro = (e) => ({
  query: (t) => e.put("v1/user/informations", t)
}), no = (e) => ({
  query: (t) => e.delete(
    `v3/user/wishlists/${t.wishlistToken}/houses/${t.wishlist.house_id}`
  )
}), so = (e) => ({
  query: (t) => e.post(
    `v3/user/automatic_proposals/${t.automaticProposalId}/automatic_proposal_comments/${t.automaticProposalHouseId}`,
    { automatic_proposal_comment: t.automatic_proposal_comment }
  )
}), oo = (e) => ({
  query: (t) => e.put(
    `v3/user/automatic_proposals/${t.automaticProposalId}/automatic_proposal_comments/${t.automaticProposalHouseId}`,
    { automatic_proposal_comment: t.automatic_proposal_comment }
  )
}), ao = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.included,
      filter: t.filters,
      pagination: t.paginate
    });
    return e.get(`v3/user/houses/${t.houseId}/bookings${r}`);
  }
}), io = (e) => ({
  query: (t) => e.post(
    `v3/user/houses/${t.houseId}/bookings/${t.bookingId}/owner_bookings/comments`,
    { comment: { content: t.comment } }
  )
}), uo = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes,
      pagination: t.pagination
    });
    return e.get(`v3/user/houses/${t.houseId}/contracts${r}`);
  }
}), co = (e) => ({
  query: (t) => {
    const r = q({ filter: t.filters });
    return e.get(
      `v3/user/houses/${t.houseId}/signatory_owner_contracts${r}`
    );
  }
}), lo = (e) => ({
  query: (t) => e.get(
    `v3/user/houses/${t.houseId}/contracts/${t.contractId}/timeline_items`
  )
}), yo = (e) => ({
  query: (t) => e.get(`v3/user/houses/${t.houseId}/contract_information`)
}), fo = (e) => ({
  query: (t) => {
    const r = t.context === "company" ? "?context=company" : "";
    return e.put(
      `v3/user/houses/${t.houseId}/contract_information${r}`,
      t.formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
}), mo = (e) => ({
  query: (t) => e.post(
    `v3/user/houses/${t.houseId}/contracts/${t.contractId}/guest_contacts`,
    { guest_contact: t.guestContact }
  )
}), ho = (e) => ({
  query: (t) => e.get(
    `v3/user/houses/${t.houseId}/owner_tax_certificates.pdf?year=${t.year}`,
    { responseType: "arraybuffer" }
  )
}), po = (e) => ({
  query: (t) => e.get(
    `v3/user/houses/${t.houseId}/owner_tax_certificate_available_years`
  )
}), go = (e) => ({
  query: (t) => e.get(`v3/user/houses/${t.houseId}/dashboard_analytics`)
}), qo = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes
    }), n = r ? `${r}&type=${t.type}` : `?type=${t.type}`;
    return e.get(`v3/user/contracts${n}`);
  }
}), wo = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes
    });
    return e.get(`v3/user/contracts/${t.type}/${t.contractId}${r}`);
  }
}), vo = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(
      `v3/user/contracts/${t.contractId}/guest_contacts${r}`
    );
  }
}), $o = (e) => ({
  query: (t) => e.get(
    `v3/user/contracts/${t.type}/${t.contractId}.pdf`,
    { responseType: "arraybuffer" }
  )
}), _o = (e) => ({
  query: (t) => e.post("v3/user/auth", t)
}), bo = (e) => ({
  query: (t) => e.post("v3/user/auth/sign_in", t)
}), Io = (e) => ({
  query: (t) => e.post("v3/user/auth/sign_in_with_token", t)
}), So = (e) => ({
  query: (t) => e.post("v3/user/auth/sign_up_with_token", t)
}), Eo = (e) => ({
  query: (t) => e.post("v3/user/auth/finish_signup", t)
}), Ao = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(
      `v3/user/houses/${t.houseId}/stay_information${r}`
    );
  }
}), To = (e) => ({
  query: (t) => e.post("v3/user/multi_inquiry_wishlists", {
    multi_inquiry_wishlist: { ...t }
  })
}), Ro = (e) => ({
  query: (t) => e.delete(
    `v3/user/multi_inquiry_wishlists/${t.wishlistToken}`
  )
}), Po = (e) => ({
  query: (t) => e.get(`v3/user/multi_inquiry_wishlists/${t.wishlistToken}`)
}), Co = (e) => ({
  query: () => e.get("v3/user/multi_inquiry_wishlists")
}), Oo = (e) => ({
  query: (t) => e.put(
    `v3/user/multi_inquiry_wishlists/${t.wishlistToken}`,
    { multi_inquiry_wishlist: { ...t } }
  )
}), ko = (e) => ({
  query: (t) => e.delete(
    `v3/user/house_multi_inquiry_wishlists/${t.houseId}`
  )
}), xo = (e) => ({
  query: (t) => e.get(`v3/user/houses/${t.houseId}/house_staffs`)
}), Uo = (e) => ({
  query: (t) => e.get(
    `v3/user/multi_inquiry_wishlist_availabilities?private_token=${t.privateToken}&check_in=${t.checkIn}&check_out=${t.checkOut}`
  )
}), Ho = (e) => ({
  query: (t) => e.put(`v3/users/${t.userId}`, { user: { ...t.user } })
}), Lo = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filters,
      includes: t.includes
    });
    return e.get(`v3/user/owner_contracts/${t.contractId}${r}`);
  }
}), Do = (e) => ({
  query: (t) => e.post(`v3/user/owner_contracts/${t.contractId}/confirms`, {
    contract: { approved_by_owner_at: t.contract.approved_by_owner_at },
    owner_general_rental_condition_signed: t.owner_general_rental_condition_signed
  })
}), Bo = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.includes
    });
    return e.get(
      `v3/user/client_contracts/${t.clientContractId}${r}`
    );
  }
}), No = (e) => ({
  query: (t) => e.post(
    `v3/user/client_contracts/${t.clientContractId}/confirms`,
    {
      contract: {
        approved_by_client_at: (/* @__PURE__ */ new Date()).toISOString()
      }
    }
  )
}), jo = (e) => ({
  query: (t, r) => {
    const n = q({
      includes: t.includes
    });
    return e.put(
      `v3/user/client_contracts/${t.clientContractId}${n}`,
      t.information,
      r
    );
  }
}), Fo = (e) => ({
  modifyUser: Ho(e).query,
  auth: {
    emailSignUp: _o(e).query,
    finishSignUp: Eo(e).query,
    phoneSignIn: bo(e).query,
    tokenSignIn: Io(e).query,
    tokenSignUp: So(e).query
  },
  automaticProposal: {
    automaticProposalComments: {
      createAutomaticProposalComment: so(e).query,
      modifyAutomaticProposalComment: oo(e).query
    }
  },
  availabilityRequest: {
    getAvailabilityRequestById: zs(e).query,
    modifyAvailabilityRequest: Js(e).query
  },
  awaitingActions: {
    getAwaitingActions: Ks(e).query,
    updateOwnerNps: Xs(e).query
  },
  checks: {
    downloadCheckPdf: Qs(e).query
  },
  clientContracts: {
    getClientContract: Bo(e).query,
    confirmClientContract: No(e).query,
    sendClientContractInformation: jo(e).query
  },
  contracts: {
    getContractsByType: qo(e).query,
    getContractsById: wo(e).query,
    getContractPdf: $o(e).query,
    getGuestContracts: vo(e).query
  },
  houses: {
    getAreasEquipments: Ws(e).query,
    getHouses: Vs(e).query,
    getHouseContacts: xo(e).query,
    bookings: {
      getBookings: ao(e).query,
      owner: {
        addComment: io(e).query
      }
    },
    getStayInformation: Ao(e).query,
    contracts: {
      addGuestContacts: mo(e).query,
      getHouseContracts: uo(e).query,
      modifyContractInformation: fo(e).query,
      getContractInformation: yo(e).query,
      getPaymentTimeline: lo(e).query,
      getSignatoryOwnerContracts: co(e).query
    },
    dashboardAnalytics: {
      getDashboardAnalytics: go(e).query
    },
    taxCertificates: {
      getOwnerTaxCertificateById: ho(e).query,
      getOwnerTaxCertificateAvailableYears: po(e).query
    }
  },
  information: {
    addHouseToUserWishlist: Ys(e).query,
    getUserInfo: Zs(e).query,
    getUserWishlist: eo(e).query,
    modifyUserInfo: to(e).query,
    oldModifyUserInfo: ro(e).query,
    removeHouseToUserWishlist: no(e).query
  },
  multiInquiryWishlistAvailabilities: {
    getWishlistAvailability: Uo(e).query
  },
  multiInquiryWishlists: {
    createWishlist: To(e).query,
    deleteWishlist: Ro(e).query,
    getWishlist: Po(e).query,
    getWishlists: Co(e).query,
    modifyWishlist: Oo(e).query
  },
  houseMultiInquiryWishlists: {
    deleteHouseWishlist: ko(e).query
  },
  ownerContracts: {
    getOwnerContractById: Lo(e).query,
    confirmOwnerContractById: Do(e).query
  }
}), Mo = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include
    });
    return e.get(
      `v3/automatic_proposals${r}&private_token=${t.privateToken}`
    );
  }
}), Wo = (e) => ({
  getAutomaticProposals: Mo(e).query
}), Go = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(
      `v3/houses/${t.houseId}${r}${t.privateToken ? `&private_token=${t.privateToken}` : ""}`
    );
  }
}), Vo = (e) => ({
  query: (t) => e.get(
    `v3/houses/${t.houseId}/key_features${t.privateToken ? `?private_token=${t.privateToken}` : ""}`
  )
}), zo = (e) => ({
  query: (t) => {
    const r = q({
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/houses/${t.houseId}/photos${r}${t.privateToken ? `&private_token=${t.privateToken}` : ""}`
    );
  }
}), Jo = (e) => ({
  query: ({
    currency: t = "EUR",
    endDate: r,
    maxBudget: n = "1000000",
    minBudget: s = "0",
    page: o = "all",
    sortBy: a = "recommended",
    startDate: i,
    states: c,
    destinationIds: d,
    housesIds: u
  }) => {
    const y = c ? `&states[]=${c}` : "", f = d && d.length > 0 ? `&${d.map((m) => `destination_ids[]=${m}`).join("&")}` : "", h = u && u.length > 0 ? `&${u.map((m) => `house_ids[]=${m}`).join("&")}` : "";
    return e.get(
      `v3/ids/house_periods?currency=${t}&end_at=${r}&max_budget=${n}&min_budget=${s}&page=${o}&start_at=${i}&sort_by=${a}${y}${f}${h}`
    );
  }
}), Ko = (e) => ({
  query: ({
    currency: t = "EUR",
    endDate: r,
    maxBudget: n = "1000000",
    minBudget: s = "0",
    page: o = "all",
    sortBy: a = "recommended",
    startDate: i,
    houseIds: c,
    destinationIds: d = []
  }) => {
    const u = `&${c.map((y) => `house_ids[]=${y.toString()}`).concat(...d.map((y) => `destination_ids[]=${y.toString()}`)).join("&")}`;
    return e.get(
      `v1/house_periods?currency=${t}&end_at=${r}&max_budget=${n}&min_budget=${s}&page=${o}&start_at=${i}&sort_by=${a}${u}`
    );
  }
}), Xo = (e) => ({
  query: (t) => e.get(
    `v3/houses/${t.houseId}/period_durations?private_token=${t.privateToken}&start_at=${t.startAt}&end_at=${t.endAt}&page=all`
  )
}), Qo = (e) => ({
  query: ({
    currency: t = "EUR",
    endDate: r,
    startDate: n,
    houseId: s
  }) => e.get(
    `v1/house_periods/${s}?currency=${t}&end_at=${r}&start_at=${n}`
  )
}), Yo = (e) => ({
  query: (t) => {
    const r = `?start_at=${t.startDate}&${t.destinationId.map((n) => `destination_ids[]=${n}`).join("&")}`;
    return e.get(`v3/period_durations/count_by_period_types${r}`);
  }
}), Zo = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(`v3/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas${r}&page=all`);
  }
}), ea = (e) => ({
  query: (t) => e.get(
    `v1/houses/${t.houseId}/bookings?private_token=${t.privateToken}&start_date=${t.startAt}&end_date=${t.endAt}&page=1&per=50`
  )
}), ta = (e) => ({
  query: (t) => e.get(
    `v3/houses/${t.houseId}/areas_equipments${t.privateToken ? `?private_token=${t.privateToken}` : ""}`
  )
}), ra = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/destinations/${t.destinationId}${r}`);
  }
}), na = (e) => ({
  query: (t) => e.get(
    `v3/houses/${t.houseId}/included_services`.concat(
      t.privateToken ? `?private_token=${t.privateToken}` : ""
    )
  )
}), sa = (e) => ({
  query: (t) => e.get(
    `v3/houses/${t.houseId}/house_truth_links${t.privateToken ? `?private_token=${t.privateToken}` : ""}`
  )
}), oa = (e) => ({
  query: (t) => e.get(`v3/houses/${t.houseId}/next_available_dates`)
}), aa = (e) => ({
  getDestinationById: ra(e).query,
  getHouseById: Go(e).query,
  getHouseIncludedServices: na(e).query,
  getHouseTruthLinks: sa(e).query,
  getHouseKeyFeatures: Vo(e).query,
  getPhotosByHouseId: zo(e).query,
  getHouseAreaEquipments: ta(e).query,
  areaGroups: {
    areas: {
      getHouseAreaGroupsAreas: Zo(e).query
    }
  },
  bookings: {
    getBookingsByHouseId: ea(e).query
  },
  periods: {
    getHousePeriodsIds: Jo(e).query,
    getHousePeriods: Ko(e).query,
    getHousePeriodsById: Qo(e).query,
    getPeriodDurations: Xo(e).query,
    getCountByPeriodTypes: Yo(e).query,
    getHouseNextValidPeriod: oa(e).query
  }
}), ia = (e) => ({
  query: (t) => e.post("v3/admin/admin_users", t)
}), ua = (e) => ({
  query: (t) => e.get(`v3/admin/admin_users/${t.userId}`)
}), ca = (e) => ({
  query: (t) => e.put(`v3/admin/admin_users/${t.userId}`, {
    admin_user: t.admin_user
  })
}), da = (e) => ({
  query: (t) => e.delete(`v3/admin/admin_users/${t.userId}`)
}), la = (e) => ({
  query: (t) => e.post(
    `v3/admin/admin_users/${t.adminUserId}/house_contacts`,
    { house_contact: t.house_contact }
  )
}), ya = (e) => ({
  query: (t) => e.delete(
    `v3/admin/admin_users/${t.adminUserId}/house_contacts/${t.houseId}`
  )
}), fa = (e) => ({
  query: () => e.get("v3/admin/ad_partner_types")
}), ma = (e) => ({
  query: () => e.get("v3/admin/area_types?page=all")
}), ha = (e) => ({
  query: (t) => {
    const r = t.attribute ? `/${t.attribute}` : "", n = q({
      filter: t.filter,
      includes: t.include,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/audits/${t.model}/${t.id}${r}${n}`
    );
  }
}), pa = (e) => ({
  query: (t) => e.post("v3/admin/auth/password", t)
}), ga = (e) => ({
  query: (t) => e.get(
    `v3/admin/auth/google_oauth2?access_token=${t.accessToken}&email=${t.email}`
  )
}), qa = (e) => ({
  query: (t) => e.put("v3/admin/auth/password", t)
}), wa = (e) => ({
  query: (t) => e.post("v3/admin/auth/sign_in", t)
}), va = (e) => ({
  query: () => e.delete("v3/admin/auth/sign_out")
}), $a = (e) => ({
  query: () => e.get("v3/admin/auth/validate_token")
}), _a = (e) => ({
  query: (t) => e.post(
    `v3/admin/areas/${t.areaId}/equipments`,
    t.payload
  )
}), ba = (e) => ({
  query: (t) => e.delete(
    `v3/admin/areas/${t.areaId}/equipments/${t.equipmentId}`
  )
}), Ia = (e) => ({
  query: (t) => e.get(`v3/admin/areas/${t.areaId}/equipments`)
}), Sa = (e) => ({
  query: (t) => e.put(
    `v3/admin/areas/${t.areaId}/equipments/${t.equipmentId}`,
    t.payload
  )
}), Ea = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter
    });
    return e.get(`v3/admin/bank_exports/${t.id}${r}`);
  }
}), Aa = (e) => ({
  query: () => e.get("v3/admin/brands?page=all")
}), Ta = (e) => ({
  query: (t) => e.post(
    `v3/admin/change_requests/${t.id}`,
    t.change_request
  )
}), Ra = (e) => ({
  query: (t) => e.post(
    `v3/admin/contracts/${t.contractId}/comments`,
    t.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), Pa = (e) => ({
  query: (t) => e.delete(
    `v3/admin/contracts/${t.contractId}/comments/${t.commentId}`
  )
}), Ca = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/contracts/${t.contractId}/comments${r}`);
  }
}), Oa = (e) => ({
  query: (t) => e.put(
    `v3/admin/contracts/${t.contractId}/comments/${t.commentId}`,
    t.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), ka = (e) => ({
  query: (t) => e.post(
    `v3/admin/contracts/${t.contractId}/client_receipts`,
    { ...t.receipt },
    {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob"
    }
  )
}), xa = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/contracts/${t.contractId}/client_receipts${r}`
    );
  }
}), Ua = (e) => ({
  query: (t) => e.post(
    `v3/admin/contracts/${t.contractId}/owner_receipts`,
    { ...t.receipt },
    { responseType: "blob" }
  )
}), Ha = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/contracts/${t.contractId}/owner_receipts${r}`
    );
  }
}), La = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/contracts/${t.contractId}/payment_transactions${r}`
    );
  }
}), Da = (e) => ({
  query: (t) => e.put(
    `v3/admin/contracts/${t.contractId}/payment_transactions/${t.ptId}`,
    t.payment_transaction
  )
}), Ba = (e) => ({
  query: (t) => e.put(
    `v3/admin/contracts/${t.contractId}/payment_transactions/${t.ptId}`,
    { payment_transaction: t.payment_transaction }
  )
}), Na = (e) => ({
  query: (t) => e.put(
    `v3/admin/contracts/${t.contractId}/manually_signed_client_contracts`,
    t.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), ja = (e) => ({
  query: (t) => e.put(
    `v3/admin/contracts/${t.contractId}/manually_signed_owner_contracts`,
    t.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), Fa = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/contracts/${t.contractId}/timeline_items${r}`
    );
  }
}), Ma = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/contracts/${t.contractId}${r}`);
  }
}), Wa = (e) => ({
  query: (t) => e.put(`v3/admin/contracts/${t.contractId}`, t.contract)
}), Ga = (e) => ({
  query: (t) => e.put(`v3/admin/contracts/${t.contractId}`, t.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), Va = (e) => ({
  query: (t) => e.post("v3/admin/credits", t.payload)
}), za = (e) => ({
  query: (t) => e.delete(`v3/admin/credits/${t.creditId}`)
}), Ja = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(`v3/admin/credits/${t.creditId}${r}`);
  }
}), Ka = (e) => ({
  query: (t) => e.put(`v3/admin/credits/${t.creditId}`, t.payload)
}), Xa = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/destinations/${t.destinationId}${r}`);
  }
}), Qa = (e) => ({
  query: (t) => e.post("v3/admin/destinations", t)
}), Ya = (e) => ({
  query: (t) => e.post(`v3/admin/destinations/${t.destinationId}`, {
    ...t.destination
  })
}), Za = (e) => ({
  query: (t) => e.delete(`v3/admin/destinations/${t.destinationId}`)
}), ei = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/destination_trees${r}`);
  }
}), ti = (e) => ({
  query: () => e.get("v3/admin/equipment_types?page=all")
}), ri = (e) => ({
  query: () => e.get("v3/admin/event_types")
}), ni = (e) => ({
  query: (t) => e.put(
    `v3/admin/expected_pay_outs/${t.expectedPayOutId}/assigns`,
    t.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), si = (e) => ({
  query: (t) => e.put(
    `v3/admin/expected_pay_outs/${t.expectedPayOutId}/credits/assigns`,
    { credit_ids: t.creditIds }
  )
}), oi = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(
      `v3/admin/expected_pay_outs/${t.expectedPayOutId}${r}`
    );
  }
}), ai = (e) => ({
  query: () => e.post("v3/admin/exports/figaro", {})
}), ii = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/exports/figaro${r}`);
  }
}), ui = (e) => ({
  query: (t) => e.post("v3/admin/exports/incoming_payment_transactions", {
    ...t
  })
}), ci = (e) => ({
  query: (t) => e.post(
    `v3/admin/exports/incoming_payment_transactions/${t.id}`,
    { ...t.export }
  )
}), di = (e) => ({
  query: (t) => e.post("v3/admin/exports/tourist_taxe", t)
}), li = (e) => ({
  query: (t) => e.put(`v3/admin/exports/tourist_taxe/${t.id}`, {
    ...t.export
  })
}), yi = (e) => ({
  query: (t) => e.post("v3/admin/financial_reports/houses_vat_recoverys", t, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), De = (e = "terms_of_services") => ["terms_of_services", "privacy_policy"].includes(e) ? e : `${e}_general_rental_conditions`, fi = (e) => ({
  query: ({
    type: t,
    ...r
  }) => e.post(`v3/admin/${De(t)}`, r)
}), mi = (e) => ({
  query: (t) => e.get(
    `v3/admin/${De(t.type)}?page=${t.page}`
  )
}), hi = (e) => ({
  query: (t) => e.get(
    `v3/admin/${De(t.type)}/${t.id}`
  )
}), pi = (e) => ({
  query: () => e.get("v3/admin/house_architectural_styles")
}), gi = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/ad_partners`,
    t.payload
  )
}), qi = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas`,
    t.payload
  )
}), wi = (e) => ({
  query: (t) => e.post(`v3/admin/houses/${t.houseId}/areas/${t.areaId}/duplicate_areas`, {
    area: t.area
  })
}), vi = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/area_groups`,
    t.payload
  )
}), $i = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/stay_information/codes`,
    t.payload
  )
}), _i = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/places/${t.placeId}/distances`,
    { ...t.params }
  )
}), bi = (e) => ({
  query: (t) => e.post("v3/admin/houses", t)
}), Ii = (e) => ({
  query: (t) => e.post(
    `v3/admin/houses/${t.houseId}/house_truth_links`,
    t.payload
  )
}), Si = (e) => ({
  query: (t) => e.post(`v3/admin/houses/${t.houseId}/links`, t.payload)
}), Ei = (e) => ({
  query: (t) => e.post(`v3/admin/houses/${t.houseId}/period_durations`, {
    ...t.period_duration
  })
}), Ai = (e) => ({
  query: (t) => e.post(`v3/admin/houses/${t.houseId}/period_prices`, {
    ...t.period_price
  })
}), Ti = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas/${t.areaId}`
  )
}), Ri = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}`
  )
}), Pi = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/stay_information/codes/${t.codeId}`
  )
}), Ci = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/house_truth_links/${t.houseTruthLinkId}`
  )
}), Oi = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/links/${t.linkId}`
  )
}), ki = (e) => ({
  query: (t) => e.get(`v3/admin/houses/${t.houseId}/ad_partners`)
}), xi = (e) => ({
  query: (t) => e.get(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas/${t.areaId}`
  )
}), Ui = (e) => ({
  query: (t) => e.get(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}`
  )
}), Hi = (e) => ({
  query: (t) => {
    var n;
    const r = q({ filter: (n = t == null ? void 0 : t.included) == null ? void 0 : n.filter });
    return e.get(`v3/admin/houses/${t.houseId}/area_groups${r}`);
  }
}), Li = (e) => ({
  query: (t) => {
    var n, s;
    const r = q({
      filter: (n = t.included) == null ? void 0 : n.filter,
      pagination: (s = t == null ? void 0 : t.included) == null ? void 0 : s.pagination
    });
    return e.get(
      `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas${r}`
    );
  }
}), Di = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.included,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/houses/${t.houseId}/signatory/credits${r}`
    );
  }
}), Bi = (e) => ({
  query: (t) => e.get(
    `v3/admin/houses/${t.houseId}/places/${t.placeId}/distances`
  )
}), Ni = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.included,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/houses/${t.houseId}${r}`);
  }
}), ji = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    if (t.houseIds.length > 0) {
      const n = `?ids=${t.houseIds.join(",")}`;
      return e.get(`v3/admin/houses${n}`, {
        ...t.params
      });
    }
    return e.get(`v3/admin/houses${r}`);
  }
}), Fi = (e) => ({
  query: (t) => e.get(`v3/admin/houses/${t.houseId}/house_truth_links`)
}), Mi = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(
      `v3/admin/houses/${t.houseId}/period_durations${r}`
    );
  }
}), Wi = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/houses/${t.houseId}/period_prices${r}`);
  }
}), Gi = (e) => ({
  query: (t) => {
    var n, s, o;
    const r = q({
      filter: (n = t.included) == null ? void 0 : n.filter,
      includes: (s = t.included) == null ? void 0 : s.includes,
      pagination: (o = t.included) == null ? void 0 : o.pagination
    });
    return e.get(`v3/admin/houses/${t.houseId}/reviews${r}`);
  }
}), Vi = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(
      `v3/admin/houses/${t.houseId}/stay_information${r}`
    );
  }
}), zi = (e) => ({
  query: (t) => e.get(`v3/admin/houses/${t.houseId}/surrounding_information`)
}), Ji = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/ad_partners`,
    t.payload
  )
}), Ki = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}/areas/${t.areaId}`,
    t.payload
  )
}), Xi = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/area_groups/${t.areaGroupId}`,
    t.payload
  )
}), Qi = (e) => ({
  query: (t) => e.put(`v3/admin/houses/${t.houseId}/areas/${t.areaId}/area_photos`, {
    area: {
      area_photos_attributes: t.photoIds.map((r) => ({
        photo_id: r
      }))
    }
  })
}), Yi = (e) => ({
  query: (t) => e.put(`v3/admin/houses/${t.houseId}/automatic_offer`, {
    automatic_offer: t.automatic_offer
  })
}), Zi = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/stay_information/codes/${t.codeId}`,
    t.payload
  )
}), eu = (e) => ({
  query: (t) => t.formData ? e.put(`v3/admin/houses/${t.houseId}`, t.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }) : e.put(`v3/admin/houses/${t.houseId}`, {
    house: t.house
  })
}), tu = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/house_truth_links/${t.houseTruthLinkId}`,
    t.payload
  )
}), ru = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/links/${t.linkId}`,
    t.payload
  )
}), nu = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/period_durations/${t.periodDurationId}`,
    { ...t.period_duration }
  )
}), su = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/period_prices/${t.periodPriceId}`,
    { ...t.period_price }
  )
}), ou = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/reviews/${t.reviewId}`,
    t.payload
  )
}), au = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/stay_information`,
    t.payload
  )
}), iu = (e) => ({
  query: (t) => e.put(
    `v3/admin/houses/${t.houseId}/surrounding_information`,
    t.payload
  )
}), uu = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/period_durations/${t.periodDurationId}`
  )
}), cu = (e) => ({
  query: (t) => e.delete(
    `v3/admin/houses/${t.houseId}/period_prices/${t.periodPriceId}`
  )
}), du = (e) => ({
  query: () => e.get("v3/admin/house_categories")
}), lu = (e) => ({
  query: (t) => e.post("v3/admin/house_staffs", t.payload)
}), yu = (e) => ({
  query: (t) => e.put(
    `v3/admin/house_staffs/${t.houseStaffId}`,
    t.payload
  )
}), fu = (e) => ({
  query: (t) => e.delete(`v3/admin/house_staffs/${t.houseStaffId}`)
}), mu = (e) => ({
  query: () => e.get("v3/admin/house_styles")
}), hu = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/included_services${r}`);
  }
}), pu = (e) => ({
  query: (t) => e.get(
    `v3/admin/owner_tax_certificates/${t.houseId}.pdf?year=${t.year}`,
    { responseType: "blob" }
  )
}), gu = (e) => ({
  query: (t) => e.put(`v3/admin/photos/${t.photoId}`, {
    position: t.position,
    hidden: t.hidden
  })
}), qu = (e) => ({
  query: (t) => e.delete(`v3/admin/photos/${t.photoId}`)
}), wu = (e) => ({
  query: (t) => e.post(
    `v3/admin/places/${t.placeId}/destination_places`,
    t.payload
  )
}), vu = (e) => ({
  query: (t) => e.post(
    `v3/admin/places/${t.placeId}/house_places`,
    t.payload
  )
}), $u = (e) => ({
  query: (t) => e.post("v3/admin/places", t.payload)
}), _u = (e) => ({
  query: (t) => e.get(`v3/admin/places/${t.placeId}`)
}), bu = (e) => ({
  query: (t) => e.put(`v3/admin/places/${t.placeId}`, t.payload)
}), Iu = (e) => ({
  query: (t) => e.delete(
    `v3/admin/places/${t.placeId}/destination_places/${t.destinationId}`
  )
}), Su = (e) => ({
  query: (t) => e.delete(
    `v3/admin/places/${t.placeId}/house_places/${t.houseId}`
  )
}), Eu = (e) => ({
  query: (t) => e.delete(`v3/admin/places/${t.placeId}`)
}), Au = (e) => ({
  query: (t) => {
    const r = q({
      includes: t.include,
      filter: t.filter,
      pagination: t.pagination
    });
    return e.get(`v3/admin/place_types${r}`);
  }
}), Tu = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(`v3/admin/pay_ins/${t.payInId}${r}`);
  }
}), Ru = (e) => ({
  query: (t) => e.post(`v3/admin/pay_ins/${t.payInId}/assigns`, t.params)
}), Pu = (e) => ({
  query: (t) => e.post("v3/admin/pools", t.payload)
}), Cu = (e) => ({
  query: (t) => e.get(`v3/admin/pools/${t.poolId}`)
}), Ou = (e) => ({
  query: (t) => e.get(`v3/admin/pools?ids=${t.poolIds.join()}`)
}), ku = (e) => ({
  query: (t) => e.put(`v3/admin/pools/${t.poolId}`, t.payload)
}), xu = (e) => ({
  query: () => e.get("v3/admin/subsidiaries")
}), Uu = (e) => ({
  query: () => e.get("v3/admin/themes")
}), Hu = (e) => ({
  query: (t) => e.post("v3/admin/users/invitation", t)
}), Lu = (e) => ({
  query: (t) => e.put(`v3/admin/users/${t.userId}/invitation`, {})
}), Du = (e) => ({
  query: (t) => e.post("v3/admin/vouchers", t.payload)
}), Bu = (e) => ({
  query: (t) => e.post(
    `v3/admin/vouchers/${t.voucherId}/assigns`,
    t.params
  )
}), Nu = (e) => ({
  query: (t) => {
    const r = q({ includes: t.included });
    return e.get(`v3/admin/vouchers/${t.voucherId}${r}`);
  }
}), ju = (e) => ({
  query: (t) => e.put(`v3/admin/vouchers/${t.voucherId}`, t.payload)
}), Fu = (e) => ({
  query: (t) => e.delete(`v3/admin/vouchers/${t.voucherId}`)
}), Mu = (e) => ({
  adminUser: {
    createAdminUser: ia(e).query,
    getAdminUser: ua(e).query,
    modifyAdminUser: ca(e).query,
    removeAdminUser: da(e).query,
    houseContacts: {
      createHouseContact: la(e).query,
      removeHouseContact: ya(e).query
    }
  },
  adPartnerType: {
    getAdPartnerTypes: fa(e).query
  },
  areaTypes: {
    getAreaTypes: ma(e).query
  },
  audits: {
    getAuditById: ha(e).query
  },
  auth: {
    forgotPassword: pa(e).query,
    googleSignIn: ga(e).query,
    resetPassword: qa(e).query,
    signIn: wa(e).query,
    signOut: va(e).query,
    validateToken: $a(e).query
  },
  areas: {
    equipements: {
      createEquipement: _a(e).query,
      deleteEquipement: ba(e).query,
      getEquipements: Ia(e).query,
      modifyEquipement: Sa(e).query
    }
  },
  bankExports: {
    getBankExports: Ea(e).query
  },
  brands: {
    getBrands: Aa(e).query
  },
  changeRequests: {
    modifyChangeRequests: Ta(e).query
  },
  generalConditions: {
    createCondition: fi(e).query,
    getConditionById: hi(e).query,
    getConditions: mi(e).query
  },
  contracts: {
    comments: {
      addComment: Ra(e).query,
      deleteComment: Pa(e).query,
      getComments: Ca(e).query,
      modifyComment: Oa(e).query
    },
    getContractById: Ma(e).query,
    manuallySignedContracts: {
      modifyClientContract: Na(e).query,
      modifyOwnerContract: ja(e).query
    },
    modifyContract: Wa(e).query,
    modifyClientInfo: Ga(e).query,
    receipts: {
      createClientReceiptByContractId: ka(e).query,
      createOwnerReceiptByContractId: Ua(e).query,
      getClientReceipByContractId: xa(e).query,
      getOwnerReceipByContractId: Ha(e).query
    },
    paymentTransactions: {
      getPaymentTransactionByContractId: La(e).query,
      modifyPaymentTransaction: Da(e).query,
      modifyPayOut: Ba(e).query
    },
    timeline: {
      getTimelineItemsByContractId: Fa(e).query
    }
  },
  credits: {
    createCredit: Va(e).query,
    deleteCredit: za(e).query,
    getCredit: Ja(e).query,
    modifyCredit: Ka(e).query
  },
  destinations: {
    addDestination: Qa(e).query,
    getDestinationById: Xa(e).query,
    modifyDestination: Ya(e).query,
    removeDestination: Za(e).query
  },
  destinationTree: {
    getTree: ei(e).query
  },
  equipementTypes: {
    getEquipementTypes: ti(e).query
  },
  eventTypes: {
    getEventTypes: ri(e).query
  },
  expectedPayOuts: {
    approveExpectedPayOut: ni(e).query,
    getExpectedPayOut: oi(e).query,
    credits: {
      assignCredits: si(e).query
    }
  },
  exports: {
    figaro: {
      addExport: ai(e).query,
      getExport: ii(e).query
    },
    incomingPaymentTransaction: {
      addExport: ui(e).query,
      modifyExport: ci(e).query
    },
    touristTaxe: {
      addExport: di(e).query,
      modifyExport: li(e).query
    }
  },
  financialReports: {
    sendHousesVatRecovery: yi(e).query
  },
  houseArchitecturalStyles: {
    getArchitecturalStyles: pi(e).query
  },
  houses: {
    adPartners: {
      addAdPartner: gi(e).query,
      getAdPartners: ki(e).query,
      modifyAdPartner: Ji(e).query
    },
    areaGroups: {
      areas: {
        addArea: qi(e).query,
        deleteArea: Ti(e).query,
        getArea: xi(e).query,
        getAreas: Li(e).query,
        modifyArea: Ki(e).query
      },
      addAreaGroup: vi(e).query,
      deleteAreaGroup: Ri(e).query,
      getAreaGroup: Ui(e).query,
      getAreaGroups: Hi(e).query,
      modifyAreaGroup: Xi(e).query
    },
    areas: {
      addAreaDuplicate: wi(e).query,
      areaPhotos: {
        modifyAreaPhotos: Qi(e).query
      }
    },
    automaticOffer: {
      modifyAutomaticOffer: Yi(e).query
    },
    houseTruthLinks: {
      addHouseTruthLink: Ii(e).query,
      deleteHouseTruthLink: Ci(e).query,
      getHouseTruthLinks: Fi(e).query,
      modifyHouseTruthLink: tu(e).query
    },
    links: {
      addLink: Si(e).query,
      deleteLink: Oi(e).query,
      modifyLink: ru(e).query
    },
    periodDurations: {
      addPeriodDuration: Ei(e).query,
      getPeriodDurations: Mi(e).query,
      modifyPeriodDuration: nu(e).query,
      removePeriodDuration: uu(e).query
    },
    periodPrices: {
      addPeriodPrice: Ai(e).query,
      getPeriodPrices: Wi(e).query,
      modifyPeriodPrice: su(e).query,
      removePeriodPrice: cu(e).query
    },
    places: {
      distances: {
        addDistance: _i(e).query,
        getDistances: Bi(e).query
      }
    },
    signatory: {
      credits: {
        getCredits: Di(e).query
      }
    },
    reviews: {
      getReviews: Gi(e).query,
      modifyReview: ou(e).query
    },
    surroundingInformation: {
      getSurroundingInformation: zi(e).query,
      modifySurroundingInformation: iu(e).query
    },
    stayInformation: {
      codes: {
        addCode: $i(e).query,
        deleteCode: Pi(e).query,
        modifyCode: Zi(e).query
      },
      getStayInformation: Vi(e).query,
      modifyStayInformation: au(e).query
    },
    addHouse: bi(e).query,
    getHouseById: Ni(e).query,
    getHouses: ji(e).query,
    modifyHouse: eu(e).query
  },
  houseCategories: {
    getHouseCategories: du(e).query
  },
  houseStaffs: {
    addHouseStaff: lu(e).query,
    modifyHouseStaff: yu(e).query,
    removeHouseStaff: fu(e).query
  },
  houseStyles: {
    getHouseStyles: mu(e).query
  },
  includedServices: {
    getIncludedServices: hu(e).query
  },
  ownerTaxCertificates: {
    getTaxCertificateById: pu(e).query
  },
  payIns: {
    assign: {
      assignPayIn: Ru(e).query
    },
    getPayIn: Tu(e).query
  },
  photos: {
    modifyPhoto: gu(e).query,
    removePhoto: qu(e).query
  },
  places: {
    destinationPlaces: {
      addDestinationPlace: wu(e).query,
      removeDestinationPlace: Iu(e).query
    },
    housePlaces: {
      addHousePlace: vu(e).query,
      removeHousePlace: Su(e).query
    },
    addPlace: $u(e).query,
    getPlaceById: _u(e).query,
    modifyPlace: bu(e).query,
    removePlace: Eu(e).query
  },
  placeTypes: {
    getPlaceTypes: Au(e).query
  },
  pools: {
    addPool: Pu(e).query,
    getPoolById: Cu(e).query,
    getPools: Ou(e).query,
    modifyPool: ku(e).query
  },
  subsidiaries: {
    getSubsidiaries: xu(e).query
  },
  themes: {
    getThemes: Uu(e).query
  },
  user: {
    invitation: {
      addInvitation: Hu(e).query,
      modifyInvitation: Lu(e).query
    }
  },
  vouchers: {
    assign: {
      assignVoucher: Bu(e).query
    },
    addVoucher: Du(e).query,
    getVoucher: Nu(e).query,
    modifyVoucher: ju(e).query,
    removeVoucher: Fu(e).query
  }
}), Wu = (e) => ({
  query: (t) => e.post("v3/contacts", t.payload)
}), Gu = (e) => ({
  createContactRequest: Wu(e).query
}), Vu = (e) => ({
  query: (t) => e.post("v3/requests", t.request)
}), zu = (e) => ({
  query: (t) => e.put(`v3/requests/${t.request_uuid}`, t.request)
}), Ju = (e) => ({
  request: {
    makeHouseRequest: Vu(e).query,
    updateInquiry: zu(e).query
  }
}), Ku = (e) => ({
  query: (t) => e.post("v3/request_wishlists", {
    request_wishlist: { ...t }
  })
}), Xu = (e) => ({
  query: (t) => e.put("v3/request_wishlists", {
    request_wishlist: { ...t }
  })
}), Qu = (e) => ({
  makeRequestWishlist: Ku(e).query,
  modifyRequestWishlist: Xu(e).query
}), Yu = (e) => ({
  query: () => e.get("v3/searchable_tags/identifiers")
}), Zu = (e) => ({
  getIdentifiers: Yu(e).query
}), ec = (e) => ({
  query: (t) => e.get(`v3/multi_inquiry_wishlists?private_token=${t.wishlistToken}`)
}), tc = (e) => ({
  getWishlistShared: ec(e).query
}), rc = (e) => ({
  query: (t) => e.get(
    `v3/tailor/contracts/${t.contractId}/client_itinerary`
  )
}), nc = (e) => ({
  query: (t) => e.get(`v3/tailor/contracts/${t}/links_and_documents`)
}), sc = (e) => ({
  query: (t) => e.get(`v3/tailor/contracts/${t.contractId}/appointments`)
}), oc = (e) => ({
  contracts: {
    getClientItinerary: rc(e).query,
    getAllDocuments: nc(e).query,
    getAppointments: sc(e).query
  }
}), ac = (e) => ({
  query: () => e.get("v3/marketplace/user/permission")
}), ic = (e) => ({
  getMarketplacePermission: ac(e).query
}), uc = (e) => ({
  query: () => e.get("v1/privacy_policy")
}), cc = (e) => ({
  getPrivacyPolicy: uc(e).query
}), dc = (e) => ({
  query: (t) => e.post("v3/newsletter_emails", t)
}), lc = (e) => ({
  subscribeNewsletter: dc(e).query
}), yc = (e) => ({
  query: (t) => e.post(`v1/user/houses/${t.houseId}/owner_bookings`, {
    owner_booking: t.period
  })
}), fc = (e) => ({
  query: (t) => e.get(`v1/user/houses/${t.houseId}/periods`)
}), mc = (e) => ({
  query: (t) => e.get(
    `v2/user/houses/${t.houseId}/contracts/${t.contractId}`
  )
}), hc = (e) => ({
  query: (t) => e.get(`v1/user/houses/${t.houseId}/calendar_exports`)
}), pc = (e) => ({
  houses: {
    calendar: {
      getCalendarExports: hc(e).query
    },
    contracts: {
      getContractById: mc(e).query
    },
    bookings: {
      owner: {
        modifyOwnerBooking: yc(e).query
      }
    },
    periods: {
      getPeriods: fc(e).query
    }
  }
}), gc = (e) => ({
  query: (t) => e.get(
    `v1/auth/password/edit?reset_password_token=${t.reset_password_token}`
  )
}), qc = (e) => ({
  query: (t) => e.post("v1/auth/password", t)
}), wc = (e) => ({
  query: (t) => e.put("v1/auth/password", t)
}), vc = (e) => ({
  query: (t) => e.put("v1/auth/password", t)
}), $c = (e) => ({
  password: {
    getResetPasswordTokenConfirmation: gc(e).query,
    sendForgottenPasswordEmail: qc(e).query,
    updateUserConnectedPassword: wc(e).query,
    updateUserDisconnectedPassword: vc(e).query
  }
}), _c = (e) => ({
  query: () => e.get("v1/auth/validate_token")
}), bc = (e) => ({
  query: (t) => e.post("v1/auth/sign_in", t)
}), Ic = (e) => ({
  query: () => e.delete("v1/auth/sign_out")
}), Sc = (e) => ({
  query: (t) => e.get(
    `v1/auth/invitation?email=${encodeURIComponent(t.email)}`
  )
}), Ec = (e) => ({
  session: {
    getValidateToken: _c(e).query,
    signIn: bc(e).query,
    signOut: Ic(e).query,
    verifyUserEmail: Sc(e).query
  }
}), Ac = (e) => Object.assign($c(e), Ec(e)), Tc = (e) => ({
  query: (t) => e.get(`v1/owner_contracts/${t.contractId}`)
}), Rc = (e) => ({
  query: (t) => {
    const r = t.ownerIsCompany ? "company" : "individual";
    return e.put(
      `v1/owner_contracts/${t.contractId}?context=${r}`,
      { contract: t.authSystem }
    );
  }
}), Pc = (e) => ({
  query: () => e.get("v1/owner_general_rental_condition")
}), Cc = (e) => ({
  owner: {
    getContractById: Tc(e).query,
    getOwnerGeneralRentalCondition: Pc(e).query,
    sendSmsOrEmailAuthSystem: Rc(e).query
  }
}), Oc = (e) => ({
  query: (t) => e.post("v1/requests", t)
}), kc = (e) => ({
  query: (t, r) => e.put(`v1/requests/${t}`, r)
}), xc = (e) => ({
  query: (t) => e.post("v1/requests", t)
}), Uc = (e) => ({
  query: (t) => e.post("v1/callback_requests", t)
}), Hc = (e) => ({
  prebooking: {
    createPrebooking: Oc(e).query,
    updatePrebooking: kc(e).query
  },
  lpRequest: {
    createLpRequest: xc(e).query
  },
  callBackRequest: {
    createCallbackRequest: Uc(e).query
  }
}), Lc = (e) => ({
  query: (t) => e.post("v2/waiting_searches", t.payload)
}), Dc = (e) => ({
  addWaitingSearch: Lc(e).query
}), Bc = (e) => ({
  query: (t) => e.get(
    `lp-destinations/find-by-slug/${t.slug}?locale=${t.locale}`
  )
}), Nc = (e) => ({
  query: (t) => e.get(
    `collection-groups?sort=id&filters[lp_inspiration]&filters[lp_destination]=${t.destinationId}`
  )
}), jc = (e) => ({
  query: (t) => e.get(
    `popular-destinations?sort=position&filters[lp_inspiration]&filters[lp_destination]=${t.destinationId}`
  )
}), Fc = (e) => ({
  getLandingPageDestination: Bc(e).query,
  getLandingPageDestinationHouses: Nc(e).query,
  getLandingPagePopularDestinations: jc(e).query
});
class Mc {
  constructor(t) {
    this.httpSource = t, this.headersCustom = null;
  }
  setHeaders({ accessToken: t, client: r, uid: n }) {
    this.headersCustom = { accessToken: t, client: r, uid: n };
  }
  getHeaders() {
    return this.headersCustom ? {
      "access-token": this.headersCustom.accessToken,
      client: this.headersCustom.client,
      uid: this.headersCustom.uid,
      ...this.httpSource ? { Httpsource: this.httpSource } : {}
    } : null;
  }
  clearHeaders() {
    this.headersCustom = null;
  }
}
class Wc {
  constructor() {
    this.localeCustom = null;
  }
  setLocale(t) {
    this.localeCustom = t;
  }
  getLocale() {
    return this.localeCustom;
  }
}
const Kc = {
  lc: ({
    api: e,
    locale: t,
    storageClient: r,
    httpClientType: n = "axios"
  }) => {
    const s = new Mc(e.source), o = new Wc(), a = (n === "axios" ? j : Ms)({
      // @ts-expect-error ResT can be instanciated with an unrelated type
      api: e,
      locale: t,
      localeCustom: o,
      storageClient: r,
      headersCustom: s
    }), i = Te(pc(a), Fo(a)), c = Te(Hc(a), Ju(a));
    return {
      admin: Mu(a),
      auth: Ac(a),
      contacts: Gu(a),
      contracts: Cc(a),
      user: i,
      houses: aa(a),
      legal: cc(a),
      request: c,
      requestWishlists: Qu(a),
      searchableTag: Zu(a),
      multiInquiryWishlists: tc(a),
      tailor: oc(a),
      automaticProposals: Wo(a),
      marketplace: ic(a),
      newsletterEmails: lc(a),
      waitingSearches: Dc(a),
      headers: s,
      localeCustom: o
    };
  },
  strapiAdmin: ({ api: e }) => {
    const t = j({ api: e, unserialized: !0 });
    return {
      lpDestination: Fc(t)
    };
  }
};
export {
  zc as ABTestService,
  Vc as DocVerifier,
  Gs as ShareGroop,
  Jc as UserLocation,
  Kc as buildRepositories
};
